// eslint-disable-next-line no-unused-vars
export const pokemon_data = {
    '1': [
        'Bulbasaur',
        '/en/pokemon/1-bulbasaur',
        '<span class="_p28" style="background-position: 0px 0px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            128,
            118,
            111
        ]
    ],
    '2': [
        'Ivysaur',
        '/en/pokemon/2-ivysaur',
        '<span class="_p28" style="background-position: -28px 0px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            155,
            151,
            143
        ]
    ],
    '3': [
        'Venusaur',
        '/en/pokemon/3-venusaur',
        '<span class="_p28" style="background-position: -56px 0px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            190,
            198,
            189
        ]
    ],
    '4': [
        'Charmander',
        '/en/pokemon/4-charmander',
        '<span class="_p28" style="background-position: -84px 0px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            118,
            116,
            93
        ]
    ],
    '5': [
        'Charmeleon',
        '/en/pokemon/5-charmeleon',
        '<span class="_p28" style="background-position: -112px 0px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            151,
            158,
            126
        ]
    ],
    '6': [
        'Charizard',
        '/en/pokemon/6-charizard',
        '<span class="_p28" style="background-position: -140px 0px;"></span>',
        '',
        [
            10,
            3
        ],
        [
            186,
            223,
            173
        ]
    ],
    '7': [
        'Squirtle',
        '/en/pokemon/7-squirtle',
        '<span class="_p28" style="background-position: -168px 0px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            127,
            94,
            121
        ]
    ],
    '8': [
        'Wartortle',
        '/en/pokemon/8-wartortle',
        '<span class="_p28" style="background-position: -196px 0px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            153,
            126,
            155
        ]
    ],
    '9': [
        'Blastoise',
        '/en/pokemon/9-blastoise',
        '<span class="_p28" style="background-position: -224px 0px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            188,
            171,
            207
        ]
    ],
    '10': [
        'Caterpie',
        '/en/pokemon/10-caterpie',
        '<span class="_p28" style="background-position: 28px 0px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            128,
            55,
            55
        ]
    ],
    '11': [
        'Metapod',
        '/en/pokemon/11-metapod',
        '<span class="_p28" style="background-position: 0px -28px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            137,
            45,
            80
        ]
    ],
    '12': [
        'Butterfree',
        '/en/pokemon/12-butterfree',
        '<span class="_p28" style="background-position: -28px -28px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            155,
            167,
            137
        ]
    ],
    '13': [
        'Weedle',
        '/en/pokemon/13-weedle',
        '<span class="_p28" style="background-position: -56px -28px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            120,
            63,
            50
        ]
    ],
    '14': [
        'Kakuna',
        '/en/pokemon/14-kakuna',
        '<span class="_p28" style="background-position: -84px -28px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            128,
            46,
            75
        ]
    ],
    '15': [
        'Beedrill',
        '/en/pokemon/15-beedrill',
        '<span class="_p28" style="background-position: -112px -28px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            163,
            169,
            130
        ]
    ],
    '16': [
        'Pidgey',
        '/en/pokemon/16-pidgey',
        '<span class="_p28" style="background-position: -140px -28px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            120,
            85,
            73
        ]
    ],
    '17': [
        'Pidgeotto',
        '/en/pokemon/17-pidgeotto',
        '<span class="_p28" style="background-position: -168px -28px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            160,
            117,
            105
        ]
    ],
    '18': [
        'Pidgeot',
        '/en/pokemon/18-pidgeot',
        '<span class="_p28" style="background-position: -196px -28px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            195,
            166,
            154
        ]
    ],
    '19': [
        'Rattata',
        '/en/pokemon/19-rattata',
        '<span class="_p28" style="background-position: -224px -28px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            102,
            103,
            70
        ]
    ],
    '20': [
        'Raticate',
        '/en/pokemon/20-raticate',
        '<span class="_p28" style="background-position: 28px -28px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            146,
            161,
            139
        ]
    ],
    '21': [
        'Spearow',
        '/en/pokemon/21-spearow',
        '<span class="_p28" style="background-position: 0px -56px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            120,
            112,
            60
        ]
    ],
    '22': [
        'Fearow',
        '/en/pokemon/22-fearow',
        '<span class="_p28" style="background-position: -28px -56px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            163,
            182,
            133
        ]
    ],
    '23': [
        'Ekans',
        '/en/pokemon/23-ekans',
        '<span class="_p28" style="background-position: -56px -56px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            111,
            110,
            97
        ]
    ],
    '24': [
        'Arbok',
        '/en/pokemon/24-arbok',
        '<span class="_p28" style="background-position: -84px -56px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            155,
            167,
            153
        ]
    ],
    '25': [
        'Pikachu',
        '/en/pokemon/25-pikachu',
        '<span class="_p28" style="background-position: -112px -56px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            111,
            112,
            96
        ]
    ],
    '26': [
        'Raichu',
        '/en/pokemon/26-raichu',
        '<span class="_p28" style="background-position: -140px -56px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            155,
            193,
            151
        ]
    ],
    '27': [
        'Sandshrew',
        '/en/pokemon/27-sandshrew',
        '<span class="_p28" style="background-position: -168px -56px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            137,
            126,
            120
        ]
    ],
    '28': [
        'Sandslash',
        '/en/pokemon/28-sandslash',
        '<span class="_p28" style="background-position: -196px -56px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            181,
            182,
            175
        ]
    ],
    '29': [
        'Nidoran♀',
        '/en/pokemon/29-nidoran',
        '<span class="_p28" style="background-position: -224px -56px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            146,
            86,
            89
        ]
    ],
    '30': [
        'Nidorina',
        '/en/pokemon/30-nidorina',
        '<span class="_p28" style="background-position: 28px -56px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            172,
            117,
            120
        ]
    ],
    '31': [
        'Nidoqueen',
        '/en/pokemon/31-nidoqueen',
        '<span class="_p28" style="background-position: 0px -84px;"></span>',
        '',
        [
            4,
            5
        ],
        [
            207,
            180,
            173
        ]
    ],
    '32': [
        'Nidoran♂',
        '/en/pokemon/32-nidoran',
        '<span class="_p28" style="background-position: -28px -84px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            130,
            105,
            76
        ]
    ],
    '33': [
        'Nidorino',
        '/en/pokemon/33-nidorino',
        '<span class="_p28" style="background-position: -56px -84px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            156,
            137,
            111
        ]
    ],
    '34': [
        'Nidoking',
        '/en/pokemon/34-nidoking',
        '<span class="_p28" style="background-position: -84px -84px;"></span>',
        '',
        [
            4,
            5
        ],
        [
            191,
            204,
            156
        ]
    ],
    '35': [
        'Clefairy',
        '/en/pokemon/35-clefairy',
        '<span class="_p28" style="background-position: -112px -84px;"></span>',
        '',
        [
            18,
            null
        ],
        [
            172,
            107,
            108
        ]
    ],
    '36': [
        'Clefable',
        '/en/pokemon/36-clefable',
        '<span class="_p28" style="background-position: -140px -84px;"></span>',
        '',
        [
            18,
            null
        ],
        [
            216,
            178,
            162
        ]
    ],
    '37': [
        'Vulpix',
        '/en/pokemon/37-vulpix',
        '<span class="_p28" style="background-position: -168px -84px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            116,
            96,
            109
        ]
    ],
    '38': [
        'Ninetales',
        '/en/pokemon/38-ninetales',
        '<span class="_p28" style="background-position: -196px -84px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            177,
            169,
            190
        ]
    ],
    '39': [
        'Jigglypuff',
        '/en/pokemon/39-jigglypuff',
        '<span class="_p28" style="background-position: -224px -84px;"></span>',
        '',
        [
            1,
            18
        ],
        [
            251,
            80,
            41
        ]
    ],
    '40': [
        'Wigglytuff',
        '/en/pokemon/40-wigglytuff',
        '<span class="_p28" style="background-position: 28px -84px;"></span>',
        '',
        [
            1,
            18
        ],
        [
            295,
            156,
            90
        ]
    ],
    '41': [
        'Zubat',
        '/en/pokemon/41-zubat',
        '<span class="_p28" style="background-position: 0px -112px;"></span>',
        '',
        [
            4,
            3
        ],
        [
            120,
            83,
            73
        ]
    ],
    '42': [
        'Golbat',
        '/en/pokemon/42-golbat',
        '<span class="_p28" style="background-position: -28px -112px;"></span>',
        '',
        [
            4,
            3
        ],
        [
            181,
            161,
            150
        ]
    ],
    '43': [
        'Oddish',
        '/en/pokemon/43-oddish',
        '<span class="_p28" style="background-position: -56px -112px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            128,
            131,
            112
        ]
    ],
    '44': [
        'Gloom',
        '/en/pokemon/44-gloom',
        '<span class="_p28" style="background-position: -84px -112px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            155,
            153,
            136
        ]
    ],
    '45': [
        'Vileplume',
        '/en/pokemon/45-vileplume',
        '<span class="_p28" style="background-position: -112px -112px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            181,
            202,
            167
        ]
    ],
    '46': [
        'Paras',
        '/en/pokemon/46-paras',
        '<span class="_p28" style="background-position: -140px -112px;"></span>',
        '',
        [
            7,
            12
        ],
        [
            111,
            121,
            99
        ]
    ],
    '47': [
        'Parasect',
        '/en/pokemon/47-parasect',
        '<span class="_p28" style="background-position: -168px -112px;"></span>',
        '',
        [
            7,
            12
        ],
        [
            155,
            165,
            146
        ]
    ],
    '48': [
        'Venonat',
        '/en/pokemon/48-venonat',
        '<span class="_p28" style="background-position: -196px -112px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            155,
            100,
            100
        ]
    ],
    '49': [
        'Venomoth',
        '/en/pokemon/49-venomoth',
        '<span class="_p28" style="background-position: -224px -112px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            172,
            179,
            143
        ]
    ],
    '50': [
        'Diglett',
        '/en/pokemon/50-diglett',
        '<span class="_p28" style="background-position: 28px -112px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            67,
            109,
            78
        ]
    ],
    '51': [
        'Dugtrio',
        '/en/pokemon/51-dugtrio',
        '<span class="_p28" style="background-position: 0px -140px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            111,
            167,
            134
        ]
    ],
    '52': [
        'Meowth',
        '/en/pokemon/52-meowth',
        '<span class="_p28" style="background-position: -28px -140px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            120,
            92,
            78
        ]
    ],
    '53': [
        'Persian',
        '/en/pokemon/53-persian',
        '<span class="_p28" style="background-position: -56px -140px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            163,
            150,
            136
        ]
    ],
    '54': [
        'Psyduck',
        '/en/pokemon/54-psyduck',
        '<span class="_p28" style="background-position: -84px -140px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            137,
            122,
            95
        ]
    ],
    '55': [
        'Golduck',
        '/en/pokemon/55-golduck',
        '<span class="_p28" style="background-position: -112px -140px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            190,
            191,
            162
        ]
    ],
    '56': [
        'Mankey',
        '/en/pokemon/56-mankey',
        '<span class="_p28" style="background-position: -140px -140px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            120,
            148,
            82
        ]
    ],
    '57': [
        'Primeape',
        '/en/pokemon/57-primeape',
        '<span class="_p28" style="background-position: -168px -140px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            163,
            207,
            138
        ]
    ],
    '58': [
        'Growlithe',
        '/en/pokemon/58-growlithe',
        '<span class="_p28" style="background-position: -196px -140px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            146,
            136,
            93
        ]
    ],
    '59': [
        'Arcanine',
        '/en/pokemon/59-arcanine',
        '<span class="_p28" style="background-position: -224px -140px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            207,
            227,
            166
        ]
    ],
    '60': [
        'Poliwag',
        '/en/pokemon/60-poliwag',
        '<span class="_p28" style="background-position: 28px -140px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            120,
            101,
            82
        ]
    ],
    '61': [
        'Poliwhirl',
        '/en/pokemon/61-poliwhirl',
        '<span class="_p28" style="background-position: 0px -168px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            163,
            130,
            123
        ]
    ],
    '62': [
        'Poliwrath',
        '/en/pokemon/62-poliwrath',
        '<span class="_p28" style="background-position: -28px -168px;"></span>',
        '',
        [
            11,
            2
        ],
        [
            207,
            182,
            184
        ]
    ],
    '63': [
        'Abra',
        '/en/pokemon/63-abra',
        '<span class="_p28" style="background-position: -56px -168px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            93,
            195,
            82
        ]
    ],
    '64': [
        'Kadabra',
        '/en/pokemon/64-kadabra',
        '<span class="_p28" style="background-position: -84px -168px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            120,
            232,
            117
        ]
    ],
    '65': [
        'Alakazam',
        '/en/pokemon/65-alakazam',
        '<span class="_p28" style="background-position: -112px -168px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            146,
            271,
            167
        ]
    ],
    '66': [
        'Machop',
        '/en/pokemon/66-machop',
        '<span class="_p28" style="background-position: -140px -168px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            172,
            137,
            82
        ]
    ],
    '67': [
        'Machoke',
        '/en/pokemon/67-machoke',
        '<span class="_p28" style="background-position: -168px -168px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            190,
            177,
            125
        ]
    ],
    '68': [
        'Machamp',
        '/en/pokemon/68-machamp',
        '<span class="_p28" style="background-position: -196px -168px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            207,
            234,
            159
        ]
    ],
    '69': [
        'Bellsprout',
        '/en/pokemon/69-bellsprout',
        '<span class="_p28" style="background-position: -224px -168px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            137,
            139,
            61
        ]
    ],
    '70': [
        'Weepinbell',
        '/en/pokemon/70-weepinbell',
        '<span class="_p28" style="background-position: 28px -168px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            163,
            172,
            92
        ]
    ],
    '71': [
        'Victreebel',
        '/en/pokemon/71-victreebel',
        '<span class="_p28" style="background-position: 0px -196px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            190,
            207,
            135
        ]
    ],
    '72': [
        'Tentacool',
        '/en/pokemon/72-tentacool',
        '<span class="_p28" style="background-position: -28px -196px;"></span>',
        '',
        [
            11,
            4
        ],
        [
            120,
            97,
            149
        ]
    ],
    '73': [
        'Tentacruel',
        '/en/pokemon/73-tentacruel',
        '<span class="_p28" style="background-position: -56px -196px;"></span>',
        '',
        [
            11,
            4
        ],
        [
            190,
            166,
            209
        ]
    ],
    '74': [
        'Geodude',
        '/en/pokemon/74-geodude',
        '<span class="_p28" style="background-position: -84px -196px;"></span>',
        '',
        [
            6,
            5
        ],
        [
            120,
            132,
            132
        ]
    ],
    '75': [
        'Graveler',
        '/en/pokemon/75-graveler',
        '<span class="_p28" style="background-position: -112px -196px;"></span>',
        '',
        [
            6,
            5
        ],
        [
            146,
            164,
            164
        ]
    ],
    '76': [
        'Golem',
        '/en/pokemon/76-golem',
        '<span class="_p28" style="background-position: -140px -196px;"></span>',
        '',
        [
            6,
            5
        ],
        [
            190,
            211,
            198
        ]
    ],
    '77': [
        'Ponyta',
        '/en/pokemon/77-ponyta',
        '<span class="_p28" style="background-position: -168px -196px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            137,
            170,
            127
        ]
    ],
    '78': [
        'Rapidash',
        '/en/pokemon/78-rapidash',
        '<span class="_p28" style="background-position: -196px -196px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            163,
            207,
            162
        ]
    ],
    '79': [
        'Slowpoke',
        '/en/pokemon/79-slowpoke',
        '<span class="_p28" style="background-position: -224px -196px;"></span>',
        '',
        [
            11,
            14
        ],
        [
            207,
            109,
            98
        ]
    ],
    '80': [
        'Slowbro',
        '/en/pokemon/80-slowbro',
        '<span class="_p28" style="background-position: 28px -196px;"></span>',
        '',
        [
            11,
            14
        ],
        [
            216,
            177,
            180
        ]
    ],
    '81': [
        'Magnemite',
        '/en/pokemon/81-magnemite',
        '<span class="_p28" style="background-position: 0px -224px;"></span>',
        '',
        [
            13,
            9
        ],
        [
            93,
            165,
            121
        ]
    ],
    '82': [
        'Magneton',
        '/en/pokemon/82-magneton',
        '<span class="_p28" style="background-position: -28px -224px;"></span>',
        '',
        [
            13,
            9
        ],
        [
            137,
            223,
            169
        ]
    ],
    '83': [
        'Farfetch\'d',
        '/en/pokemon/83-farfetchd',
        '<span class="_p28" style="background-position: -56px -224px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            141,
            124,
            115
        ]
    ],
    '84': [
        'Doduo',
        '/en/pokemon/84-doduo',
        '<span class="_p28" style="background-position: -84px -224px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            111,
            158,
            83
        ]
    ],
    '85': [
        'Dodrio',
        '/en/pokemon/85-dodrio',
        '<span class="_p28" style="background-position: -112px -224px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            155,
            218,
            140
        ]
    ],
    '86': [
        'Seel',
        '/en/pokemon/86-seel',
        '<span class="_p28" style="background-position: -140px -224px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            163,
            85,
            121
        ]
    ],
    '87': [
        'Dewgong',
        '/en/pokemon/87-dewgong',
        '<span class="_p28" style="background-position: -168px -224px;"></span>',
        '',
        [
            11,
            15
        ],
        [
            207,
            139,
            177
        ]
    ],
    '88': [
        'Grimer',
        '/en/pokemon/88-grimer',
        '<span class="_p28" style="background-position: -196px -224px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            190,
            135,
            90
        ]
    ],
    '89': [
        'Muk',
        '/en/pokemon/89-muk',
        '<span class="_p28" style="background-position: -224px -224px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            233,
            190,
            172
        ]
    ],
    '90': [
        'Shellder',
        '/en/pokemon/90-shellder',
        '<span class="_p28" style="background-position: 28px -224px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            102,
            116,
            134
        ]
    ],
    '91': [
        'Cloyster',
        '/en/pokemon/91-cloyster',
        '<span class="_p28" style="background-position: 0px -252px;"></span>',
        '',
        [
            11,
            15
        ],
        [
            137,
            186,
            256
        ]
    ],
    '92': [
        'Gastly',
        '/en/pokemon/92-gastly',
        '<span class="_p28" style="background-position: -28px -252px;"></span>',
        '',
        [
            8,
            4
        ],
        [
            102,
            186,
            67
        ]
    ],
    '93': [
        'Haunter',
        '/en/pokemon/93-haunter',
        '<span class="_p28" style="background-position: -56px -252px;"></span>',
        '',
        [
            8,
            4
        ],
        [
            128,
            223,
            107
        ]
    ],
    '94': [
        'Gengar',
        '/en/pokemon/94-gengar',
        '<span class="_p28" style="background-position: -84px -252px;"></span>',
        '',
        [
            8,
            4
        ],
        [
            155,
            261,
            149
        ]
    ],
    '95': [
        'Onix',
        '/en/pokemon/95-onix',
        '<span class="_p28" style="background-position: -112px -252px;"></span>',
        '',
        [
            6,
            5
        ],
        [
            111,
            85,
            232
        ]
    ],
    '96': [
        'Drowzee',
        '/en/pokemon/96-drowzee',
        '<span class="_p28" style="background-position: -140px -252px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            155,
            89,
            136
        ]
    ],
    '97': [
        'Hypno',
        '/en/pokemon/97-hypno',
        '<span class="_p28" style="background-position: -168px -252px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            198,
            144,
            193
        ]
    ],
    '98': [
        'Krabby',
        '/en/pokemon/98-krabby',
        '<span class="_p28" style="background-position: -196px -252px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            102,
            181,
            124
        ]
    ],
    '99': [
        'Kingler',
        '/en/pokemon/99-kingler',
        '<span class="_p28" style="background-position: -224px -252px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            146,
            240,
            181
        ]
    ],
    '100': [
        'Voltorb',
        '/en/pokemon/100-voltorb',
        '<span class="_p28" style="background-position: 28px -252px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            120,
            109,
            111
        ]
    ],
    '101': [
        'Electrode',
        '/en/pokemon/101-electrode',
        '<span class="_p28" style="background-position: 0px -280px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            155,
            173,
            173
        ]
    ],
    '102': [
        'Exeggcute',
        '/en/pokemon/102-exeggcute',
        '<span class="_p28" style="background-position: -28px -280px;"></span>',
        '',
        [
            12,
            14
        ],
        [
            155,
            107,
            125
        ]
    ],
    '103': [
        'Exeggutor',
        '/en/pokemon/103-exeggutor',
        '<span class="_p28" style="background-position: -56px -280px;"></span>',
        '',
        [
            12,
            14
        ],
        [
            216,
            233,
            149
        ]
    ],
    '104': [
        'Cubone',
        '/en/pokemon/104-cubone',
        '<span class="_p28" style="background-position: -84px -280px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            137,
            90,
            144
        ]
    ],
    '105': [
        'Marowak',
        '/en/pokemon/105-marowak',
        '<span class="_p28" style="background-position: -112px -280px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            155,
            144,
            186
        ]
    ],
    '106': [
        'Hitmonlee',
        '/en/pokemon/106-hitmonlee',
        '<span class="_p28" style="background-position: -140px -280px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            137,
            224,
            181
        ]
    ],
    '107': [
        'Hitmonchan',
        '/en/pokemon/107-hitmonchan',
        '<span class="_p28" style="background-position: -168px -280px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            137,
            193,
            197
        ]
    ],
    '108': [
        'Lickitung',
        '/en/pokemon/108-lickitung',
        '<span class="_p28" style="background-position: -196px -280px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            207,
            108,
            137
        ]
    ],
    '109': [
        'Koffing',
        '/en/pokemon/109-koffing',
        '<span class="_p28" style="background-position: -224px -280px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            120,
            119,
            141
        ]
    ],
    '110': [
        'Weezing',
        '/en/pokemon/110-weezing',
        '<span class="_p28" style="background-position: 28px -280px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            163,
            174,
            197
        ]
    ],
    '111': [
        'Rhyhorn',
        '/en/pokemon/111-rhyhorn',
        '<span class="_p28" style="background-position: 0px -308px;"></span>',
        '',
        [
            5,
            6
        ],
        [
            190,
            140,
            127
        ]
    ],
    '112': [
        'Rhydon',
        '/en/pokemon/112-rhydon',
        '<span class="_p28" style="background-position: -28px -308px;"></span>',
        '',
        [
            5,
            6
        ],
        [
            233,
            222,
            171
        ]
    ],
    '113': [
        'Chansey',
        '/en/pokemon/113-chansey',
        '<span class="_p28" style="background-position: -56px -308px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            487,
            60,
            128
        ]
    ],
    '114': [
        'Tangela',
        '/en/pokemon/114-tangela',
        '<span class="_p28" style="background-position: -84px -308px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            163,
            183,
            169
        ]
    ],
    '115': [
        'Kangaskhan',
        '/en/pokemon/115-kangaskhan',
        '<span class="_p28" style="background-position: -112px -308px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            233,
            181,
            165
        ]
    ],
    '116': [
        'Horsea',
        '/en/pokemon/116-horsea',
        '<span class="_p28" style="background-position: -140px -308px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            102,
            129,
            103
        ]
    ],
    '117': [
        'Seadra',
        '/en/pokemon/117-seadra',
        '<span class="_p28" style="background-position: -168px -308px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            146,
            187,
            156
        ]
    ],
    '118': [
        'Goldeen',
        '/en/pokemon/118-goldeen',
        '<span class="_p28" style="background-position: -196px -308px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            128,
            123,
            110
        ]
    ],
    '119': [
        'Seaking',
        '/en/pokemon/119-seaking',
        '<span class="_p28" style="background-position: -224px -308px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            190,
            175,
            147
        ]
    ],
    '120': [
        'Staryu',
        '/en/pokemon/120-staryu',
        '<span class="_p28" style="background-position: 28px -308px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            102,
            137,
            112
        ]
    ],
    '121': [
        'Starmie',
        '/en/pokemon/121-starmie',
        '<span class="_p28" style="background-position: 0px -336px;"></span>',
        '',
        [
            11,
            14
        ],
        [
            155,
            210,
            184
        ]
    ],
    '122': [
        'Mr. Mime',
        '/en/pokemon/122-mr-mime',
        '<span class="_p28" style="background-position: -28px -336px;"></span>',
        '',
        [
            14,
            18
        ],
        [
            120,
            192,
            205
        ]
    ],
    '123': [
        'Scyther',
        '/en/pokemon/123-scyther',
        '<span class="_p28" style="background-position: -56px -336px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            172,
            218,
            170
        ]
    ],
    '124': [
        'Jynx',
        '/en/pokemon/124-jynx',
        '<span class="_p28" style="background-position: -84px -336px;"></span>',
        '',
        [
            15,
            14
        ],
        [
            163,
            223,
            151
        ]
    ],
    '125': [
        'Electabuzz',
        '/en/pokemon/125-electabuzz',
        '<span class="_p28" style="background-position: -112px -336px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            163,
            198,
            158
        ]
    ],
    '126': [
        'Magmar',
        '/en/pokemon/126-magmar',
        '<span class="_p28" style="background-position: -140px -336px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            163,
            206,
            154
        ]
    ],
    '127': [
        'Pinsir',
        '/en/pokemon/127-pinsir',
        '<span class="_p28" style="background-position: -168px -336px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            163,
            238,
            182
        ]
    ],
    '128': [
        'Tauros',
        '/en/pokemon/128-tauros',
        '<span class="_p28" style="background-position: -196px -336px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            181,
            198,
            183
        ]
    ],
    '129': [
        'Magikarp',
        '/en/pokemon/129-magikarp',
        '<span class="_p28" style="background-position: -224px -336px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            85,
            29,
            85
        ]
    ],
    '130': [
        'Gyarados',
        '/en/pokemon/130-gyarados',
        '<span class="_p28" style="background-position: 28px -336px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            216,
            237,
            186
        ]
    ],
    '131': [
        'Lapras',
        '/en/pokemon/131-lapras',
        '<span class="_p28" style="background-position: 0px -364px;"></span>',
        '',
        [
            11,
            15
        ],
        [
            277,
            165,
            174
        ]
    ],
    '132': [
        'Ditto',
        '/en/pokemon/132-ditto',
        '<span class="_p28" style="background-position: -28px -364px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            134,
            91,
            91
        ]
    ],
    '133': [
        'Eevee',
        '/en/pokemon/133-eevee',
        '<span class="_p28" style="background-position: -56px -364px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            146,
            104,
            114
        ]
    ],
    '134': [
        'Vaporeon',
        '/en/pokemon/134-vaporeon',
        '<span class="_p28" style="background-position: -84px -364px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            277,
            205,
            161
        ]
    ],
    '135': [
        'Jolteon',
        '/en/pokemon/135-jolteon',
        '<span class="_p28" style="background-position: -112px -364px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            163,
            232,
            182
        ]
    ],
    '136': [
        'Flareon',
        '/en/pokemon/136-flareon',
        '<span class="_p28" style="background-position: -140px -364px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            163,
            246,
            179
        ]
    ],
    '137': [
        'Porygon',
        '/en/pokemon/137-porygon',
        '<span class="_p28" style="background-position: -168px -364px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            163,
            153,
            136
        ]
    ],
    '138': [
        'Omanyte',
        '/en/pokemon/138-omanyte',
        '<span class="_p28" style="background-position: -196px -364px;"></span>',
        '',
        [
            6,
            11
        ],
        [
            111,
            155,
            153
        ]
    ],
    '139': [
        'Omastar',
        '/en/pokemon/139-omastar',
        '<span class="_p28" style="background-position: -224px -364px;"></span>',
        '',
        [
            6,
            11
        ],
        [
            172,
            207,
            201
        ]
    ],
    '140': [
        'Kabuto',
        '/en/pokemon/140-kabuto',
        '<span class="_p28" style="background-position: 28px -364px;"></span>',
        '',
        [
            6,
            11
        ],
        [
            102,
            148,
            140
        ]
    ],
    '141': [
        'Kabutops',
        '/en/pokemon/141-kabutops',
        '<span class="_p28" style="background-position: 0px -392px;"></span>',
        '',
        [
            6,
            11
        ],
        [
            155,
            220,
            186
        ]
    ],
    '142': [
        'Aerodactyl',
        '/en/pokemon/142-aerodactyl',
        '<span class="_p28" style="background-position: -28px -392px;"></span>',
        '',
        [
            6,
            3
        ],
        [
            190,
            221,
            159
        ]
    ],
    '143': [
        'Snorlax',
        '/en/pokemon/143-snorlax',
        '<span class="_p28" style="background-position: -56px -392px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            330,
            190,
            169
        ]
    ],
    '144': [
        'Articuno',
        '/en/pokemon/144-articuno',
        '<span class="_p28" style="background-position: -84px -392px;"></span>',
        ' p-legendary',
        [
            15,
            3
        ],
        [
            207,
            192,
            236
        ]
    ],
    '145': [
        'Zapdos',
        '/en/pokemon/145-zapdos',
        '<span class="_p28" style="background-position: -112px -392px;"></span>',
        ' p-legendary',
        [
            13,
            3
        ],
        [
            207,
            253,
            185
        ]
    ],
    '146': [
        'Moltres',
        '/en/pokemon/146-moltres',
        '<span class="_p28" style="background-position: -140px -392px;"></span>',
        ' p-legendary',
        [
            10,
            3
        ],
        [
            207,
            251,
            181
        ]
    ],
    '147': [
        'Dratini',
        '/en/pokemon/147-dratini',
        '<span class="_p28" style="background-position: -168px -392px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            121,
            119,
            91
        ]
    ],
    '148': [
        'Dragonair',
        '/en/pokemon/148-dragonair',
        '<span class="_p28" style="background-position: -196px -392px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            156,
            163,
            135
        ]
    ],
    '149': [
        'Dragonite',
        '/en/pokemon/149-dragonite',
        '<span class="_p28" style="background-position: -224px -392px;"></span>',
        '',
        [
            16,
            3
        ],
        [
            209,
            263,
            198
        ]
    ],
    '150': [
        'Mewtwo',
        '/en/pokemon/150-mewtwo',
        '<span class="_p28" style="background-position: 28px -392px;"></span>',
        ' p-legendary',
        [
            14,
            null
        ],
        [
            214,
            300,
            182
        ]
    ],
    '151': [
        'Mew',
        '/en/pokemon/151-mew',
        '<span class="_p28" style="background-position: 0px -420px;"></span>',
        ' p-mythical',
        [
            14,
            null
        ],
        [
            225,
            210,
            210
        ]
    ],
    '152': [
        'Chikorita',
        '/en/pokemon/152-chikorita',
        '<span class="_p28" style="background-position: -28px -420px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            128,
            92,
            122
        ]
    ],
    '153': [
        'Bayleef',
        '/en/pokemon/153-bayleef',
        '<span class="_p28" style="background-position: -56px -420px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            155,
            122,
            155
        ]
    ],
    '154': [
        'Meganium',
        '/en/pokemon/154-meganium',
        '<span class="_p28" style="background-position: -84px -420px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            190,
            168,
            202
        ]
    ],
    '155': [
        'Cyndaquil',
        '/en/pokemon/155-cyndaquil',
        '<span class="_p28" style="background-position: -112px -420px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            118,
            116,
            93
        ]
    ],
    '156': [
        'Quilava',
        '/en/pokemon/156-quilava',
        '<span class="_p28" style="background-position: -140px -420px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            151,
            158,
            126
        ]
    ],
    '157': [
        'Typhlosion',
        '/en/pokemon/157-typhlosion',
        '<span class="_p28" style="background-position: -168px -420px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            186,
            223,
            173
        ]
    ],
    '158': [
        'Totodile',
        '/en/pokemon/158-totodile',
        '<span class="_p28" style="background-position: -196px -420px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            137,
            117,
            109
        ]
    ],
    '159': [
        'Croconaw',
        '/en/pokemon/159-croconaw',
        '<span class="_p28" style="background-position: -224px -420px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            163,
            150,
            142
        ]
    ],
    '160': [
        'Feraligatr',
        '/en/pokemon/160-feraligatr',
        '<span class="_p28" style="background-position: 28px -420px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            198,
            205,
            188
        ]
    ],
    '161': [
        'Sentret',
        '/en/pokemon/161-sentret',
        '<span class="_p28" style="background-position: 0px -448px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            111,
            79,
            73
        ]
    ],
    '162': [
        'Furret',
        '/en/pokemon/162-furret',
        '<span class="_p28" style="background-position: -28px -448px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            198,
            148,
            125
        ]
    ],
    '163': [
        'Hoothoot',
        '/en/pokemon/163-hoothoot',
        '<span class="_p28" style="background-position: -56px -448px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            155,
            67,
            88
        ]
    ],
    '164': [
        'Noctowl',
        '/en/pokemon/164-noctowl',
        '<span class="_p28" style="background-position: -84px -448px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            225,
            145,
            156
        ]
    ],
    '165': [
        'Ledyba',
        '/en/pokemon/165-ledyba',
        '<span class="_p28" style="background-position: -112px -448px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            120,
            72,
            118
        ]
    ],
    '166': [
        'Ledian',
        '/en/pokemon/166-ledian',
        '<span class="_p28" style="background-position: -140px -448px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            146,
            107,
            179
        ]
    ],
    '167': [
        'Spinarak',
        '/en/pokemon/167-spinarak',
        '<span class="_p28" style="background-position: -168px -448px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            120,
            105,
            73
        ]
    ],
    '168': [
        'Ariados',
        '/en/pokemon/168-ariados',
        '<span class="_p28" style="background-position: -196px -448px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            172,
            161,
            124
        ]
    ],
    '169': [
        'Crobat',
        '/en/pokemon/169-crobat',
        '<span class="_p28" style="background-position: -224px -448px;"></span>',
        '',
        [
            4,
            3
        ],
        [
            198,
            194,
            178
        ]
    ],
    '170': [
        'Chinchou',
        '/en/pokemon/170-chinchou',
        '<span class="_p28" style="background-position: 28px -448px;"></span>',
        '',
        [
            11,
            13
        ],
        [
            181,
            106,
            97
        ]
    ],
    '171': [
        'Lanturn',
        '/en/pokemon/171-lanturn',
        '<span class="_p28" style="background-position: 0px -476px;"></span>',
        '',
        [
            11,
            13
        ],
        [
            268,
            146,
            137
        ]
    ],
    '172': [
        'Pichu',
        '/en/pokemon/172-pichu',
        '<span class="_p28" style="background-position: -28px -476px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            85,
            77,
            53
        ]
    ],
    '173': [
        'Cleffa',
        '/en/pokemon/173-cleffa',
        '<span class="_p28" style="background-position: -56px -476px;"></span>',
        '',
        [
            18,
            null
        ],
        [
            137,
            75,
            79
        ]
    ],
    '174': [
        'Igglybuff',
        '/en/pokemon/174-igglybuff',
        '<span class="_p28" style="background-position: -84px -476px;"></span>',
        '',
        [
            1,
            18
        ],
        [
            207,
            69,
            32
        ]
    ],
    '175': [
        'Togepi',
        '/en/pokemon/175-togepi',
        '<span class="_p28" style="background-position: -112px -476px;"></span>',
        '',
        [
            18,
            null
        ],
        [
            111,
            67,
            116
        ]
    ],
    '176': [
        'Togetic',
        '/en/pokemon/176-togetic',
        '<span class="_p28" style="background-position: -140px -476px;"></span>',
        '',
        [
            18,
            3
        ],
        [
            146,
            139,
            181
        ]
    ],
    '177': [
        'Natu',
        '/en/pokemon/177-natu',
        '<span class="_p28" style="background-position: -168px -476px;"></span>',
        '',
        [
            14,
            3
        ],
        [
            120,
            134,
            89
        ]
    ],
    '178': [
        'Xatu',
        '/en/pokemon/178-xatu',
        '<span class="_p28" style="background-position: -196px -476px;"></span>',
        '',
        [
            14,
            3
        ],
        [
            163,
            192,
            146
        ]
    ],
    '179': [
        'Mareep',
        '/en/pokemon/179-mareep',
        '<span class="_p28" style="background-position: -224px -476px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            146,
            114,
            79
        ]
    ],
    '180': [
        'Flaaffy',
        '/en/pokemon/180-flaaffy',
        '<span class="_p28" style="background-position: 28px -476px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            172,
            145,
            109
        ]
    ],
    '181': [
        'Ampharos',
        '/en/pokemon/181-ampharos',
        '<span class="_p28" style="background-position: 0px -504px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            207,
            211,
            169
        ]
    ],
    '182': [
        'Bellossom',
        '/en/pokemon/182-bellossom',
        '<span class="_p28" style="background-position: -28px -504px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            181,
            169,
            186
        ]
    ],
    '183': [
        'Marill',
        '/en/pokemon/183-marill',
        '<span class="_p28" style="background-position: -56px -504px;"></span>',
        '',
        [
            11,
            18
        ],
        [
            172,
            37,
            93
        ]
    ],
    '184': [
        'Azumarill',
        '/en/pokemon/184-azumarill',
        '<span class="_p28" style="background-position: -84px -504px;"></span>',
        '',
        [
            11,
            18
        ],
        [
            225,
            112,
            152
        ]
    ],
    '185': [
        'Sudowoodo',
        '/en/pokemon/185-sudowoodo',
        '<span class="_p28" style="background-position: -112px -504px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            172,
            167,
            176
        ]
    ],
    '186': [
        'Politoed',
        '/en/pokemon/186-politoed',
        '<span class="_p28" style="background-position: -140px -504px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            207,
            174,
            179
        ]
    ],
    '187': [
        'Hoppip',
        '/en/pokemon/187-hoppip',
        '<span class="_p28" style="background-position: -168px -504px;"></span>',
        '',
        [
            12,
            3
        ],
        [
            111,
            67,
            94
        ]
    ],
    '188': [
        'Skiploom',
        '/en/pokemon/188-skiploom',
        '<span class="_p28" style="background-position: -196px -504px;"></span>',
        '',
        [
            12,
            3
        ],
        [
            146,
            91,
            120
        ]
    ],
    '189': [
        'Jumpluff',
        '/en/pokemon/189-jumpluff',
        '<span class="_p28" style="background-position: -224px -504px;"></span>',
        '',
        [
            12,
            3
        ],
        [
            181,
            118,
            183
        ]
    ],
    '190': [
        'Aipom',
        '/en/pokemon/190-aipom',
        '<span class="_p28" style="background-position: 28px -504px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            146,
            136,
            112
        ]
    ],
    '191': [
        'Sunkern',
        '/en/pokemon/191-sunkern',
        '<span class="_p28" style="background-position: 0px -532px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            102,
            55,
            55
        ]
    ],
    '192': [
        'Sunflora',
        '/en/pokemon/192-sunflora',
        '<span class="_p28" style="background-position: -28px -532px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            181,
            185,
            135
        ]
    ],
    '193': [
        'Yanma',
        '/en/pokemon/193-yanma',
        '<span class="_p28" style="background-position: -56px -532px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            163,
            154,
            94
        ]
    ],
    '194': [
        'Wooper',
        '/en/pokemon/194-wooper',
        '<span class="_p28" style="background-position: -84px -532px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            146,
            75,
            66
        ]
    ],
    '195': [
        'Quagsire',
        '/en/pokemon/195-quagsire',
        '<span class="_p28" style="background-position: -112px -532px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            216,
            152,
            143
        ]
    ],
    '196': [
        'Espeon',
        '/en/pokemon/196-espeon',
        '<span class="_p28" style="background-position: -140px -532px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            163,
            261,
            175
        ]
    ],
    '197': [
        'Umbreon',
        '/en/pokemon/197-umbreon',
        '<span class="_p28" style="background-position: -168px -532px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            216,
            126,
            240
        ]
    ],
    '198': [
        'Murkrow',
        '/en/pokemon/198-murkrow',
        '<span class="_p28" style="background-position: -196px -532px;"></span>',
        '',
        [
            17,
            3
        ],
        [
            155,
            175,
            87
        ]
    ],
    '199': [
        'Slowking',
        '/en/pokemon/199-slowking',
        '<span class="_p28" style="background-position: -224px -532px;"></span>',
        '',
        [
            11,
            14
        ],
        [
            216,
            177,
            180
        ]
    ],
    '200': [
        'Misdreavus',
        '/en/pokemon/200-misdreavus',
        '<span class="_p28" style="background-position: 28px -532px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            155,
            167,
            154
        ]
    ],
    '201': [
        'Unown',
        '/en/pokemon/201-unown',
        '<span class="_p28" style="background-position: 0px -560px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            134,
            136,
            91
        ]
    ],
    '202': [
        'Wobbuffet',
        '/en/pokemon/202-wobbuffet',
        '<span class="_p28" style="background-position: -28px -560px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            382,
            60,
            106
        ]
    ],
    '203': [
        'Girafarig',
        '/en/pokemon/203-girafarig',
        '<span class="_p28" style="background-position: -56px -560px;"></span>',
        '',
        [
            1,
            14
        ],
        [
            172,
            182,
            133
        ]
    ],
    '204': [
        'Pineco',
        '/en/pokemon/204-pineco',
        '<span class="_p28" style="background-position: -84px -560px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            137,
            108,
            122
        ]
    ],
    '205': [
        'Forretress',
        '/en/pokemon/205-forretress',
        '<span class="_p28" style="background-position: -112px -560px;"></span>',
        '',
        [
            7,
            9
        ],
        [
            181,
            161,
            205
        ]
    ],
    '206': [
        'Dunsparce',
        '/en/pokemon/206-dunsparce',
        '<span class="_p28" style="background-position: -140px -560px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            225,
            131,
            128
        ]
    ],
    '207': [
        'Gligar',
        '/en/pokemon/207-gligar',
        '<span class="_p28" style="background-position: -168px -560px;"></span>',
        '',
        [
            5,
            3
        ],
        [
            163,
            143,
            184
        ]
    ],
    '208': [
        'Steelix',
        '/en/pokemon/208-steelix',
        '<span class="_p28" style="background-position: -196px -560px;"></span>',
        '',
        [
            9,
            5
        ],
        [
            181,
            148,
            272
        ]
    ],
    '209': [
        'Snubbull',
        '/en/pokemon/209-snubbull',
        '<span class="_p28" style="background-position: -224px -560px;"></span>',
        '',
        [
            18,
            null
        ],
        [
            155,
            137,
            85
        ]
    ],
    '210': [
        'Granbull',
        '/en/pokemon/210-granbull',
        '<span class="_p28" style="background-position: 28px -560px;"></span>',
        '',
        [
            18,
            null
        ],
        [
            207,
            212,
            131
        ]
    ],
    '211': [
        'Qwilfish',
        '/en/pokemon/211-qwilfish',
        '<span class="_p28" style="background-position: 0px -588px;"></span>',
        '',
        [
            11,
            4
        ],
        [
            163,
            184,
            138
        ]
    ],
    '212': [
        'Scizor',
        '/en/pokemon/212-scizor',
        '<span class="_p28" style="background-position: -28px -588px;"></span>',
        '',
        [
            7,
            9
        ],
        [
            172,
            236,
            181
        ]
    ],
    '213': [
        'Shuckle',
        '/en/pokemon/213-shuckle',
        '<span class="_p28" style="background-position: -56px -588px;"></span>',
        '',
        [
            7,
            6
        ],
        [
            85,
            17,
            396
        ]
    ],
    '214': [
        'Heracross',
        '/en/pokemon/214-heracross',
        '<span class="_p28" style="background-position: -84px -588px;"></span>',
        '',
        [
            7,
            2
        ],
        [
            190,
            234,
            179
        ]
    ],
    '215': [
        'Sneasel',
        '/en/pokemon/215-sneasel',
        '<span class="_p28" style="background-position: -112px -588px;"></span>',
        '',
        [
            17,
            15
        ],
        [
            146,
            189,
            146
        ]
    ],
    '216': [
        'Teddiursa',
        '/en/pokemon/216-teddiursa',
        '<span class="_p28" style="background-position: -140px -588px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            155,
            142,
            93
        ]
    ],
    '217': [
        'Ursaring',
        '/en/pokemon/217-ursaring',
        '<span class="_p28" style="background-position: -168px -588px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            207,
            236,
            144
        ]
    ],
    '218': [
        'Slugma',
        '/en/pokemon/218-slugma',
        '<span class="_p28" style="background-position: -196px -588px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            120,
            118,
            71
        ]
    ],
    '219': [
        'Magcargo',
        '/en/pokemon/219-magcargo',
        '<span class="_p28" style="background-position: -224px -588px;"></span>',
        '',
        [
            10,
            6
        ],
        [
            137,
            139,
            191
        ]
    ],
    '220': [
        'Swinub',
        '/en/pokemon/220-swinub',
        '<span class="_p28" style="background-position: 28px -588px;"></span>',
        '',
        [
            15,
            5
        ],
        [
            137,
            90,
            69
        ]
    ],
    '221': [
        'Piloswine',
        '/en/pokemon/221-piloswine',
        '<span class="_p28" style="background-position: 0px -616px;"></span>',
        '',
        [
            15,
            5
        ],
        [
            225,
            181,
            138
        ]
    ],
    '222': [
        'Corsola',
        '/en/pokemon/222-corsola',
        '<span class="_p28" style="background-position: -28px -616px;"></span>',
        '',
        [
            11,
            6
        ],
        [
            146,
            118,
            156
        ]
    ],
    '223': [
        'Remoraid',
        '/en/pokemon/223-remoraid',
        '<span class="_p28" style="background-position: -56px -616px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            111,
            127,
            69
        ]
    ],
    '224': [
        'Octillery',
        '/en/pokemon/224-octillery',
        '<span class="_p28" style="background-position: -84px -616px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            181,
            197,
            141
        ]
    ],
    '225': [
        'Delibird',
        '/en/pokemon/225-delibird',
        '<span class="_p28" style="background-position: -112px -616px;"></span>',
        '',
        [
            15,
            3
        ],
        [
            128,
            128,
            90
        ]
    ],
    '226': [
        'Mantine',
        '/en/pokemon/226-mantine',
        '<span class="_p28" style="background-position: -140px -616px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            163,
            148,
            226
        ]
    ],
    '227': [
        'Skarmory',
        '/en/pokemon/227-skarmory',
        '<span class="_p28" style="background-position: -168px -616px;"></span>',
        '',
        [
            9,
            3
        ],
        [
            163,
            148,
            226
        ]
    ],
    '228': [
        'Houndour',
        '/en/pokemon/228-houndour',
        '<span class="_p28" style="background-position: -196px -616px;"></span>',
        '',
        [
            17,
            10
        ],
        [
            128,
            152,
            83
        ]
    ],
    '229': [
        'Houndoom',
        '/en/pokemon/229-houndoom',
        '<span class="_p28" style="background-position: -224px -616px;"></span>',
        '',
        [
            17,
            10
        ],
        [
            181,
            224,
            144
        ]
    ],
    '230': [
        'Kingdra',
        '/en/pokemon/230-kingdra',
        '<span class="_p28" style="background-position: 28px -616px;"></span>',
        '',
        [
            11,
            16
        ],
        [
            181,
            194,
            194
        ]
    ],
    '231': [
        'Phanpy',
        '/en/pokemon/231-phanpy',
        '<span class="_p28" style="background-position: 0px -644px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            207,
            107,
            98
        ]
    ],
    '232': [
        'Donphan',
        '/en/pokemon/232-donphan',
        '<span class="_p28" style="background-position: -28px -644px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            207,
            214,
            185
        ]
    ],
    '233': [
        'Porygon2',
        '/en/pokemon/233-porygon2',
        '<span class="_p28" style="background-position: -56px -644px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            198,
            198,
            180
        ]
    ],
    '234': [
        'Stantler',
        '/en/pokemon/234-stantler',
        '<span class="_p28" style="background-position: -84px -644px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            177,
            192,
            131
        ]
    ],
    '235': [
        'Smeargle',
        '/en/pokemon/235-smeargle',
        '<span class="_p28" style="background-position: -112px -644px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            146,
            40,
            83
        ]
    ],
    '236': [
        'Tyrogue',
        '/en/pokemon/236-tyrogue',
        '<span class="_p28" style="background-position: -140px -644px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            111,
            64,
            64
        ]
    ],
    '237': [
        'Hitmontop',
        '/en/pokemon/237-hitmontop',
        '<span class="_p28" style="background-position: -168px -644px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            137,
            173,
            207
        ]
    ],
    '238': [
        'Smoochum',
        '/en/pokemon/238-smoochum',
        '<span class="_p28" style="background-position: -196px -644px;"></span>',
        '',
        [
            15,
            14
        ],
        [
            128,
            153,
            91
        ]
    ],
    '239': [
        'Elekid',
        '/en/pokemon/239-elekid',
        '<span class="_p28" style="background-position: -224px -644px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            128,
            135,
            101
        ]
    ],
    '240': [
        'Magby',
        '/en/pokemon/240-magby',
        '<span class="_p28" style="background-position: 28px -644px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            128,
            151,
            99
        ]
    ],
    '241': [
        'Miltank',
        '/en/pokemon/241-miltank',
        '<span class="_p28" style="background-position: 0px -672px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            216,
            157,
            193
        ]
    ],
    '242': [
        'Blissey',
        '/en/pokemon/242-blissey',
        '<span class="_p28" style="background-position: -28px -672px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            496,
            129,
            169
        ]
    ],
    '243': [
        'Raikou',
        '/en/pokemon/243-raikou',
        '<span class="_p28" style="background-position: -56px -672px;"></span>',
        ' p-legendary',
        [
            13,
            null
        ],
        [
            207,
            241,
            195
        ]
    ],
    '244': [
        'Entei',
        '/en/pokemon/244-entei',
        '<span class="_p28" style="background-position: -84px -672px;"></span>',
        ' p-legendary',
        [
            10,
            null
        ],
        [
            251,
            235,
            171
        ]
    ],
    '245': [
        'Suicune',
        '/en/pokemon/245-suicune',
        '<span class="_p28" style="background-position: -112px -672px;"></span>',
        ' p-legendary',
        [
            11,
            null
        ],
        [
            225,
            180,
            235
        ]
    ],
    '246': [
        'Larvitar',
        '/en/pokemon/246-larvitar',
        '<span class="_p28" style="background-position: -140px -672px;"></span>',
        '',
        [
            6,
            5
        ],
        [
            137,
            115,
            93
        ]
    ],
    '247': [
        'Pupitar',
        '/en/pokemon/247-pupitar',
        '<span class="_p28" style="background-position: -168px -672px;"></span>',
        '',
        [
            6,
            5
        ],
        [
            172,
            155,
            133
        ]
    ],
    '248': [
        'Tyranitar',
        '/en/pokemon/248-tyranitar',
        '<span class="_p28" style="background-position: -196px -672px;"></span>',
        '',
        [
            6,
            17
        ],
        [
            225,
            251,
            207
        ]
    ],
    '249': [
        'Lugia',
        '/en/pokemon/249-lugia',
        '<span class="_p28" style="background-position: -224px -672px;"></span>',
        ' p-legendary',
        [
            14,
            3
        ],
        [
            235,
            193,
            310
        ]
    ],
    '250': [
        'Ho-Oh',
        '/en/pokemon/250-ho-oh',
        '<span class="_p28" style="background-position: 28px -672px;"></span>',
        ' p-legendary',
        [
            10,
            3
        ],
        [
            214,
            239,
            244
        ]
    ],
    '251': [
        'Celebi',
        '/en/pokemon/251-celebi',
        '<span class="_p28" style="background-position: 0px -700px;"></span>',
        ' p-mythical',
        [
            14,
            12
        ],
        [
            225,
            210,
            210
        ]
    ],
    '252': [
        'Treecko',
        '/en/pokemon/252-treecko',
        '<span class="_p28" style="background-position: -28px -700px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            120,
            124,
            94
        ]
    ],
    '253': [
        'Grovyle',
        '/en/pokemon/253-grovyle',
        '<span class="_p28" style="background-position: -56px -700px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            137,
            172,
            120
        ]
    ],
    '254': [
        'Sceptile',
        '/en/pokemon/254-sceptile',
        '<span class="_p28" style="background-position: -84px -700px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            172,
            223,
            169
        ]
    ],
    '255': [
        'Torchic',
        '/en/pokemon/255-torchic',
        '<span class="_p28" style="background-position: -112px -700px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            128,
            130,
            87
        ]
    ],
    '256': [
        'Combusken',
        '/en/pokemon/256-combusken',
        '<span class="_p28" style="background-position: -140px -700px;"></span>',
        '',
        [
            10,
            2
        ],
        [
            155,
            163,
            115
        ]
    ],
    '257': [
        'Blaziken',
        '/en/pokemon/257-blaziken',
        '<span class="_p28" style="background-position: -168px -700px;"></span>',
        '',
        [
            10,
            2
        ],
        [
            190,
            240,
            141
        ]
    ],
    '258': [
        'Mudkip',
        '/en/pokemon/258-mudkip',
        '<span class="_p28" style="background-position: -196px -700px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            137,
            126,
            93
        ]
    ],
    '259': [
        'Marshtomp',
        '/en/pokemon/259-marshtomp',
        '<span class="_p28" style="background-position: -224px -700px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            172,
            156,
            133
        ]
    ],
    '260': [
        'Swampert',
        '/en/pokemon/260-swampert',
        '<span class="_p28" style="background-position: 28px -700px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            225,
            208,
            175
        ]
    ],
    '261': [
        'Poochyena',
        '/en/pokemon/261-poochyena',
        '<span class="_p28" style="background-position: 0px -728px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            111,
            96,
            61
        ]
    ],
    '262': [
        'Mightyena',
        '/en/pokemon/262-mightyena',
        '<span class="_p28" style="background-position: -28px -728px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            172,
            171,
            132
        ]
    ],
    '263': [
        'Zigzagoon',
        '/en/pokemon/263-zigzagoon',
        '<span class="_p28" style="background-position: -56px -728px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            116,
            58,
            80
        ]
    ],
    '264': [
        'Linoone',
        '/en/pokemon/264-linoone',
        '<span class="_p28" style="background-position: -84px -728px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            186,
            142,
            128
        ]
    ],
    '265': [
        'Wurmple',
        '/en/pokemon/265-wurmple',
        '<span class="_p28" style="background-position: -112px -728px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            128,
            75,
            59
        ]
    ],
    '266': [
        'Silcoon',
        '/en/pokemon/266-silcoon',
        '<span class="_p28" style="background-position: -140px -728px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            137,
            60,
            77
        ]
    ],
    '267': [
        'Beautifly',
        '/en/pokemon/267-beautifly',
        '<span class="_p28" style="background-position: -168px -728px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            155,
            189,
            98
        ]
    ],
    '268': [
        'Cascoon',
        '/en/pokemon/268-cascoon',
        '<span class="_p28" style="background-position: -196px -728px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            137,
            60,
            77
        ]
    ],
    '269': [
        'Dustox',
        '/en/pokemon/269-dustox',
        '<span class="_p28" style="background-position: -224px -728px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            155,
            98,
            162
        ]
    ],
    '270': [
        'Lotad',
        '/en/pokemon/270-lotad',
        '<span class="_p28" style="background-position: 28px -728px;"></span>',
        '',
        [
            11,
            12
        ],
        [
            120,
            71,
            77
        ]
    ],
    '271': [
        'Lombre',
        '/en/pokemon/271-lombre',
        '<span class="_p28" style="background-position: 0px -756px;"></span>',
        '',
        [
            11,
            12
        ],
        [
            155,
            112,
            119
        ]
    ],
    '272': [
        'Ludicolo',
        '/en/pokemon/272-ludicolo',
        '<span class="_p28" style="background-position: -28px -756px;"></span>',
        '',
        [
            11,
            12
        ],
        [
            190,
            173,
            176
        ]
    ],
    '273': [
        'Seedot',
        '/en/pokemon/273-seedot',
        '<span class="_p28" style="background-position: -56px -756px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            120,
            71,
            77
        ]
    ],
    '274': [
        'Nuzleaf',
        '/en/pokemon/274-nuzleaf',
        '<span class="_p28" style="background-position: -84px -756px;"></span>',
        '',
        [
            12,
            17
        ],
        [
            172,
            134,
            78
        ]
    ],
    '275': [
        'Shiftry',
        '/en/pokemon/275-shiftry',
        '<span class="_p28" style="background-position: -112px -756px;"></span>',
        '',
        [
            12,
            17
        ],
        [
            207,
            200,
            121
        ]
    ],
    '276': [
        'Taillow',
        '/en/pokemon/276-taillow',
        '<span class="_p28" style="background-position: -140px -756px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            120,
            106,
            61
        ]
    ],
    '277': [
        'Swellow',
        '/en/pokemon/277-swellow',
        '<span class="_p28" style="background-position: -168px -756px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            155,
            185,
            124
        ]
    ],
    '278': [
        'Wingull',
        '/en/pokemon/278-wingull',
        '<span class="_p28" style="background-position: -196px -756px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            120,
            106,
            61
        ]
    ],
    '279': [
        'Pelipper',
        '/en/pokemon/279-pelipper',
        '<span class="_p28" style="background-position: -224px -756px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            155,
            175,
            174
        ]
    ],
    '280': [
        'Ralts',
        '/en/pokemon/280-ralts',
        '<span class="_p28" style="background-position: 28px -756px;"></span>',
        '',
        [
            14,
            18
        ],
        [
            99,
            79,
            59
        ]
    ],
    '281': [
        'Kirlia',
        '/en/pokemon/281-kirlia',
        '<span class="_p28" style="background-position: 0px -784px;"></span>',
        '',
        [
            14,
            18
        ],
        [
            116,
            117,
            90
        ]
    ],
    '282': [
        'Gardevoir',
        '/en/pokemon/282-gardevoir',
        '<span class="_p28" style="background-position: -28px -784px;"></span>',
        '',
        [
            14,
            18
        ],
        [
            169,
            237,
            195
        ]
    ],
    '283': [
        'Surskit',
        '/en/pokemon/283-surskit',
        '<span class="_p28" style="background-position: -56px -784px;"></span>',
        '',
        [
            7,
            11
        ],
        [
            120,
            93,
            87
        ]
    ],
    '284': [
        'Masquerain',
        '/en/pokemon/284-masquerain',
        '<span class="_p28" style="background-position: -84px -784px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            172,
            192,
            150
        ]
    ],
    '285': [
        'Shroomish',
        '/en/pokemon/285-shroomish',
        '<span class="_p28" style="background-position: -112px -784px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            155,
            74,
            110
        ]
    ],
    '286': [
        'Breloom',
        '/en/pokemon/286-breloom',
        '<span class="_p28" style="background-position: -140px -784px;"></span>',
        '',
        [
            12,
            2
        ],
        [
            155,
            241,
            144
        ]
    ],
    '287': [
        'Slakoth',
        '/en/pokemon/287-slakoth',
        '<span class="_p28" style="background-position: -168px -784px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            155,
            104,
            92
        ]
    ],
    '288': [
        'Vigoroth',
        '/en/pokemon/288-vigoroth',
        '<span class="_p28" style="background-position: -196px -784px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            190,
            159,
            145
        ]
    ],
    '289': [
        'Slaking',
        '/en/pokemon/289-slaking',
        '<span class="_p28" style="background-position: -224px -784px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            284,
            290,
            166
        ]
    ],
    '290': [
        'Nincada',
        '/en/pokemon/290-nincada',
        '<span class="_p28" style="background-position: 28px -784px;"></span>',
        '',
        [
            7,
            5
        ],
        [
            104,
            80,
            126
        ]
    ],
    '291': [
        'Ninjask',
        '/en/pokemon/291-ninjask',
        '<span class="_p28" style="background-position: 0px -812px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            156,
            199,
            112
        ]
    ],
    '292': [
        'Shedinja',
        '/en/pokemon/292-shedinja',
        '<span class="_p28" style="background-position: -28px -812px;"></span>',
        '',
        [
            7,
            8
        ],
        [
            1,
            153,
            73
        ]
    ],
    '293': [
        'Whismur',
        '/en/pokemon/293-whismur',
        '<span class="_p28" style="background-position: -56px -812px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            162,
            92,
            42
        ]
    ],
    '294': [
        'Loudred',
        '/en/pokemon/294-loudred',
        '<span class="_p28" style="background-position: -84px -812px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            197,
            134,
            81
        ]
    ],
    '295': [
        'Exploud',
        '/en/pokemon/295-exploud',
        '<span class="_p28" style="background-position: -112px -812px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            232,
            179,
            137
        ]
    ],
    '296': [
        'Makuhita',
        '/en/pokemon/296-makuhita',
        '<span class="_p28" style="background-position: -140px -812px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            176,
            99,
            54
        ]
    ],
    '297': [
        'Hariyama',
        '/en/pokemon/297-hariyama',
        '<span class="_p28" style="background-position: -168px -812px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            302,
            209,
            114
        ]
    ],
    '298': [
        'Azurill',
        '/en/pokemon/298-azurill',
        '<span class="_p28" style="background-position: -196px -812px;"></span>',
        '',
        [
            1,
            18
        ],
        [
            137,
            36,
            71
        ]
    ],
    '299': [
        'Nosepass',
        '/en/pokemon/299-nosepass',
        '<span class="_p28" style="background-position: -224px -812px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            102,
            82,
            215
        ]
    ],
    '300': [
        'Skitty',
        '/en/pokemon/300-skitty',
        '<span class="_p28" style="background-position: 28px -812px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            137,
            84,
            79
        ]
    ],
    '301': [
        'Delcatty',
        '/en/pokemon/301-delcatty',
        '<span class="_p28" style="background-position: 0px -840px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            172,
            132,
            127
        ]
    ],
    '302': [
        'Sableye',
        '/en/pokemon/302-sableye',
        '<span class="_p28" style="background-position: -28px -840px;"></span>',
        '',
        [
            17,
            8
        ],
        [
            137,
            141,
            136
        ]
    ],
    '303': [
        'Mawile',
        '/en/pokemon/303-mawile',
        '<span class="_p28" style="background-position: -56px -840px;"></span>',
        '',
        [
            9,
            18
        ],
        [
            137,
            155,
            141
        ]
    ],
    '304': [
        'Aron',
        '/en/pokemon/304-aron',
        '<span class="_p28" style="background-position: -84px -840px;"></span>',
        '',
        [
            9,
            6
        ],
        [
            137,
            121,
            141
        ]
    ],
    '305': [
        'Lairon',
        '/en/pokemon/305-lairon',
        '<span class="_p28" style="background-position: -112px -840px;"></span>',
        '',
        [
            9,
            6
        ],
        [
            155,
            158,
            198
        ]
    ],
    '306': [
        'Aggron',
        '/en/pokemon/306-aggron',
        '<span class="_p28" style="background-position: -140px -840px;"></span>',
        '',
        [
            9,
            6
        ],
        [
            172,
            198,
            257
        ]
    ],
    '307': [
        'Meditite',
        '/en/pokemon/307-meditite',
        '<span class="_p28" style="background-position: -168px -840px;"></span>',
        '',
        [
            2,
            14
        ],
        [
            102,
            78,
            107
        ]
    ],
    '308': [
        'Medicham',
        '/en/pokemon/308-medicham',
        '<span class="_p28" style="background-position: -196px -840px;"></span>',
        '',
        [
            2,
            14
        ],
        [
            155,
            121,
            152
        ]
    ],
    '309': [
        'Electrike',
        '/en/pokemon/309-electrike',
        '<span class="_p28" style="background-position: -224px -840px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            120,
            123,
            78
        ]
    ],
    '310': [
        'Manectric',
        '/en/pokemon/310-manectric',
        '<span class="_p28" style="background-position: 28px -840px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            172,
            215,
            127
        ]
    ],
    '311': [
        'Plusle',
        '/en/pokemon/311-plusle',
        '<span class="_p28" style="background-position: 0px -868px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            155,
            167,
            129
        ]
    ],
    '312': [
        'Minun',
        '/en/pokemon/312-minun',
        '<span class="_p28" style="background-position: -28px -868px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            155,
            147,
            150
        ]
    ],
    '313': [
        'Volbeat',
        '/en/pokemon/313-volbeat',
        '<span class="_p28" style="background-position: -56px -868px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            163,
            143,
            166
        ]
    ],
    '314': [
        'Illumise',
        '/en/pokemon/314-illumise',
        '<span class="_p28" style="background-position: -84px -868px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            163,
            143,
            166
        ]
    ],
    '315': [
        'Roselia',
        '/en/pokemon/315-roselia',
        '<span class="_p28" style="background-position: -112px -868px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            137,
            186,
            131
        ]
    ],
    '316': [
        'Gulpin',
        '/en/pokemon/316-gulpin',
        '<span class="_p28" style="background-position: -140px -868px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            172,
            80,
            99
        ]
    ],
    '317': [
        'Swalot',
        '/en/pokemon/317-swalot',
        '<span class="_p28" style="background-position: -168px -868px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            225,
            140,
            159
        ]
    ],
    '318': [
        'Carvanha',
        '/en/pokemon/318-carvanha',
        '<span class="_p28" style="background-position: -196px -868px;"></span>',
        '',
        [
            11,
            17
        ],
        [
            128,
            171,
            39
        ]
    ],
    '319': [
        'Sharpedo',
        '/en/pokemon/319-sharpedo',
        '<span class="_p28" style="background-position: -224px -868px;"></span>',
        '',
        [
            11,
            17
        ],
        [
            172,
            243,
            83
        ]
    ],
    '320': [
        'Wailmer',
        '/en/pokemon/320-wailmer',
        '<span class="_p28" style="background-position: 28px -868px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            277,
            136,
            68
        ]
    ],
    '321': [
        'Wailord',
        '/en/pokemon/321-wailord',
        '<span class="_p28" style="background-position: 0px -896px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            347,
            175,
            87
        ]
    ],
    '322': [
        'Numel',
        '/en/pokemon/322-numel',
        '<span class="_p28" style="background-position: -28px -896px;"></span>',
        '',
        [
            10,
            5
        ],
        [
            155,
            119,
            79
        ]
    ],
    '323': [
        'Camerupt',
        '/en/pokemon/323-camerupt',
        '<span class="_p28" style="background-position: -56px -896px;"></span>',
        '',
        [
            10,
            5
        ],
        [
            172,
            194,
            136
        ]
    ],
    '324': [
        'Torkoal',
        '/en/pokemon/324-torkoal',
        '<span class="_p28" style="background-position: -84px -896px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            172,
            151,
            203
        ]
    ],
    '325': [
        'Spoink',
        '/en/pokemon/325-spoink',
        '<span class="_p28" style="background-position: -112px -896px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            155,
            125,
            122
        ]
    ],
    '326': [
        'Grumpig',
        '/en/pokemon/326-grumpig',
        '<span class="_p28" style="background-position: -140px -896px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            190,
            171,
            188
        ]
    ],
    '327': [
        'Spinda',
        '/en/pokemon/327-spinda',
        '<span class="_p28" style="background-position: -168px -896px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            155,
            116,
            116
        ]
    ],
    '328': [
        'Trapinch',
        '/en/pokemon/328-trapinch',
        '<span class="_p28" style="background-position: -196px -896px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            128,
            162,
            78
        ]
    ],
    '329': [
        'Vibrava',
        '/en/pokemon/329-vibrava',
        '<span class="_p28" style="background-position: -224px -896px;"></span>',
        '',
        [
            5,
            16
        ],
        [
            137,
            134,
            99
        ]
    ],
    '330': [
        'Flygon',
        '/en/pokemon/330-flygon',
        '<span class="_p28" style="background-position: 28px -896px;"></span>',
        '',
        [
            5,
            16
        ],
        [
            190,
            205,
            168
        ]
    ],
    '331': [
        'Cacnea',
        '/en/pokemon/331-cacnea',
        '<span class="_p28" style="background-position: 0px -924px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            137,
            156,
            74
        ]
    ],
    '332': [
        'Cacturne',
        '/en/pokemon/332-cacturne',
        '<span class="_p28" style="background-position: -28px -924px;"></span>',
        '',
        [
            12,
            17
        ],
        [
            172,
            221,
            115
        ]
    ],
    '333': [
        'Swablu',
        '/en/pokemon/333-swablu',
        '<span class="_p28" style="background-position: -56px -924px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            128,
            76,
            132
        ]
    ],
    '334': [
        'Altaria',
        '/en/pokemon/334-altaria',
        '<span class="_p28" style="background-position: -84px -924px;"></span>',
        '',
        [
            16,
            3
        ],
        [
            181,
            141,
            201
        ]
    ],
    '335': [
        'Zangoose',
        '/en/pokemon/335-zangoose',
        '<span class="_p28" style="background-position: -112px -924px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            177,
            222,
            124
        ]
    ],
    '336': [
        'Seviper',
        '/en/pokemon/336-seviper',
        '<span class="_p28" style="background-position: -140px -924px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            177,
            196,
            118
        ]
    ],
    '337': [
        'Lunatone',
        '/en/pokemon/337-lunatone',
        '<span class="_p28" style="background-position: -168px -924px;"></span>',
        '',
        [
            6,
            14
        ],
        [
            207,
            178,
            153
        ]
    ],
    '338': [
        'Solrock',
        '/en/pokemon/338-solrock',
        '<span class="_p28" style="background-position: -196px -924px;"></span>',
        '',
        [
            6,
            14
        ],
        [
            207,
            178,
            153
        ]
    ],
    '339': [
        'Barboach',
        '/en/pokemon/339-barboach',
        '<span class="_p28" style="background-position: -224px -924px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            137,
            93,
            82
        ]
    ],
    '340': [
        'Whiscash',
        '/en/pokemon/340-whiscash',
        '<span class="_p28" style="background-position: 28px -924px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            242,
            151,
            141
        ]
    ],
    '341': [
        'Corphish',
        '/en/pokemon/341-corphish',
        '<span class="_p28" style="background-position: 0px -952px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            125,
            141,
            99
        ]
    ],
    '342': [
        'Crawdaunt',
        '/en/pokemon/342-crawdaunt',
        '<span class="_p28" style="background-position: -28px -952px;"></span>',
        '',
        [
            11,
            17
        ],
        [
            160,
            224,
            142
        ]
    ],
    '343': [
        'Baltoy',
        '/en/pokemon/343-baltoy',
        '<span class="_p28" style="background-position: -56px -952px;"></span>',
        '',
        [
            5,
            14
        ],
        [
            120,
            77,
            124
        ]
    ],
    '344': [
        'Claydol',
        '/en/pokemon/344-claydol',
        '<span class="_p28" style="background-position: -84px -952px;"></span>',
        '',
        [
            5,
            14
        ],
        [
            155,
            140,
            229
        ]
    ],
    '345': [
        'Lileep',
        '/en/pokemon/345-lileep',
        '<span class="_p28" style="background-position: -112px -952px;"></span>',
        '',
        [
            6,
            12
        ],
        [
            165,
            105,
            150
        ]
    ],
    '346': [
        'Cradily',
        '/en/pokemon/346-cradily',
        '<span class="_p28" style="background-position: -140px -952px;"></span>',
        '',
        [
            6,
            12
        ],
        [
            200,
            152,
            194
        ]
    ],
    '347': [
        'Anorith',
        '/en/pokemon/347-anorith',
        '<span class="_p28" style="background-position: -168px -952px;"></span>',
        '',
        [
            6,
            7
        ],
        [
            128,
            176,
            100
        ]
    ],
    '348': [
        'Armaldo',
        '/en/pokemon/348-armaldo',
        '<span class="_p28" style="background-position: -196px -952px;"></span>',
        '',
        [
            6,
            7
        ],
        [
            181,
            222,
            174
        ]
    ],
    '349': [
        'Feebas',
        '/en/pokemon/349-feebas',
        '<span class="_p28" style="background-position: -224px -952px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            85,
            29,
            85
        ]
    ],
    '350': [
        'Milotic',
        '/en/pokemon/350-milotic',
        '<span class="_p28" style="background-position: 28px -952px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            216,
            192,
            219
        ]
    ],
    '351': [
        'Castform',
        '/en/pokemon/351-castform',
        '<span class="_p28" style="background-position: 0px -980px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            172,
            139,
            139
        ]
    ],
    '352': [
        'Kecleon',
        '/en/pokemon/352-kecleon',
        '<span class="_p28" style="background-position: -28px -980px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            155,
            161,
            189
        ]
    ],
    '353': [
        'Shuppet',
        '/en/pokemon/353-shuppet',
        '<span class="_p28" style="background-position: -56px -980px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            127,
            138,
            65
        ]
    ],
    '354': [
        'Banette',
        '/en/pokemon/354-banette',
        '<span class="_p28" style="background-position: -84px -980px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            162,
            218,
            126
        ]
    ],
    '355': [
        'Duskull',
        '/en/pokemon/355-duskull',
        '<span class="_p28" style="background-position: -112px -980px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            85,
            70,
            162
        ]
    ],
    '356': [
        'Dusclops',
        '/en/pokemon/356-dusclops',
        '<span class="_p28" style="background-position: -140px -980px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            120,
            124,
            234
        ]
    ],
    '357': [
        'Tropius',
        '/en/pokemon/357-tropius',
        '<span class="_p28" style="background-position: -168px -980px;"></span>',
        '',
        [
            12,
            3
        ],
        [
            223,
            136,
            163
        ]
    ],
    '358': [
        'Chimecho',
        '/en/pokemon/358-chimecho',
        '<span class="_p28" style="background-position: -196px -980px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            181,
            175,
            170
        ]
    ],
    '359': [
        'Absol',
        '/en/pokemon/359-absol',
        '<span class="_p28" style="background-position: -224px -980px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            163,
            246,
            120
        ]
    ],
    '360': [
        'Wynaut',
        '/en/pokemon/360-wynaut',
        '<span class="_p28" style="background-position: 28px -980px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            216,
            41,
            86
        ]
    ],
    '361': [
        'Snorunt',
        '/en/pokemon/361-snorunt',
        '<span class="_p28" style="background-position: 0px -1008px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            137,
            95,
            95
        ]
    ],
    '362': [
        'Glalie',
        '/en/pokemon/362-glalie',
        '<span class="_p28" style="background-position: -28px -1008px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            190,
            162,
            162
        ]
    ],
    '363': [
        'Spheal',
        '/en/pokemon/363-spheal',
        '<span class="_p28" style="background-position: -56px -1008px;"></span>',
        '',
        [
            15,
            11
        ],
        [
            172,
            95,
            90
        ]
    ],
    '364': [
        'Sealeo',
        '/en/pokemon/364-sealeo',
        '<span class="_p28" style="background-position: -84px -1008px;"></span>',
        '',
        [
            15,
            11
        ],
        [
            207,
            137,
            132
        ]
    ],
    '365': [
        'Walrein',
        '/en/pokemon/365-walrein',
        '<span class="_p28" style="background-position: -112px -1008px;"></span>',
        '',
        [
            15,
            11
        ],
        [
            242,
            182,
            176
        ]
    ],
    '366': [
        'Clamperl',
        '/en/pokemon/366-clamperl',
        '<span class="_p28" style="background-position: -140px -1008px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            111,
            133,
            135
        ]
    ],
    '367': [
        'Huntail',
        '/en/pokemon/367-huntail',
        '<span class="_p28" style="background-position: -168px -1008px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            146,
            197,
            179
        ]
    ],
    '368': [
        'Gorebyss',
        '/en/pokemon/368-gorebyss',
        '<span class="_p28" style="background-position: -196px -1008px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            146,
            211,
            179
        ]
    ],
    '369': [
        'Relicanth',
        '/en/pokemon/369-relicanth',
        '<span class="_p28" style="background-position: -224px -1008px;"></span>',
        '',
        [
            11,
            6
        ],
        [
            225,
            162,
            203
        ]
    ],
    '370': [
        'Luvdisc',
        '/en/pokemon/370-luvdisc',
        '<span class="_p28" style="background-position: 28px -1008px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            125,
            81,
            128
        ]
    ],
    '371': [
        'Bagon',
        '/en/pokemon/371-bagon',
        '<span class="_p28" style="background-position: 0px -1036px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            128,
            134,
            93
        ]
    ],
    '372': [
        'Shelgon',
        '/en/pokemon/372-shelgon',
        '<span class="_p28" style="background-position: -28px -1036px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            163,
            172,
            155
        ]
    ],
    '373': [
        'Salamence',
        '/en/pokemon/373-salamence',
        '<span class="_p28" style="background-position: -56px -1036px;"></span>',
        '',
        [
            16,
            3
        ],
        [
            216,
            277,
            168
        ]
    ],
    '374': [
        'Beldum',
        '/en/pokemon/374-beldum',
        '<span class="_p28" style="background-position: -84px -1036px;"></span>',
        '',
        [
            9,
            14
        ],
        [
            120,
            96,
            132
        ]
    ],
    '375': [
        'Metang',
        '/en/pokemon/375-metang',
        '<span class="_p28" style="background-position: -112px -1036px;"></span>',
        '',
        [
            9,
            14
        ],
        [
            155,
            138,
            176
        ]
    ],
    '376': [
        'Metagross',
        '/en/pokemon/376-metagross',
        '<span class="_p28" style="background-position: -140px -1036px;"></span>',
        '',
        [
            9,
            14
        ],
        [
            190,
            257,
            228
        ]
    ],
    '377': [
        'Regirock',
        '/en/pokemon/377-regirock',
        '<span class="_p28" style="background-position: -168px -1036px;"></span>',
        ' p-legendary',
        [
            6,
            null
        ],
        [
            190,
            179,
            309
        ]
    ],
    '378': [
        'Regice',
        '/en/pokemon/378-regice',
        '<span class="_p28" style="background-position: -196px -1036px;"></span>',
        ' p-legendary',
        [
            15,
            null
        ],
        [
            190,
            179,
            309
        ]
    ],
    '379': [
        'Registeel',
        '/en/pokemon/379-registeel',
        '<span class="_p28" style="background-position: -224px -1036px;"></span>',
        ' p-legendary',
        [
            9,
            null
        ],
        [
            190,
            143,
            285
        ]
    ],
    '380': [
        'Latias',
        '/en/pokemon/380-latias',
        '<span class="_p28" style="background-position: 28px -1036px;"></span>',
        ' p-legendary',
        [
            16,
            14
        ],
        [
            190,
            228,
            246
        ]
    ],
    '381': [
        'Latios',
        '/en/pokemon/381-latios',
        '<span class="_p28" style="background-position: 0px -1064px;"></span>',
        ' p-legendary',
        [
            16,
            14
        ],
        [
            190,
            268,
            212
        ]
    ],
    '382': [
        'Kyogre',
        '/en/pokemon/382-kyogre',
        '<span class="_p28" style="background-position: -28px -1064px;"></span>',
        ' p-legendary',
        [
            11,
            null
        ],
        [
            205,
            270,
            228
        ]
    ],
    '383': [
        'Groudon',
        '/en/pokemon/383-groudon',
        '<span class="_p28" style="background-position: -56px -1064px;"></span>',
        ' p-legendary',
        [
            5,
            null
        ],
        [
            205,
            270,
            228
        ]
    ],
    '384': [
        'Rayquaza',
        '/en/pokemon/384-rayquaza',
        '<span class="_p28" style="background-position: -84px -1064px;"></span>',
        ' p-legendary',
        [
            16,
            3
        ],
        [
            213,
            284,
            170
        ]
    ],
    '385': [
        'Jirachi',
        '/en/pokemon/385-jirachi',
        '<span class="_p28" style="background-position: -112px -1064px;"></span>',
        ' p-mythical',
        [
            9,
            14
        ],
        [
            225,
            210,
            210
        ]
    ],
    '386': [
        'Deoxys',
        '/en/pokemon/386-deoxys',
        '<span class="_p28" style="background-position: -140px -1064px;"></span>',
        ' p-mythical',
        [
            14,
            null
        ],
        [
            137,
            345,
            115
        ]
    ],
    '387': [
        'Turtwig',
        '/en/pokemon/387-turtwig',
        '<span class="_p28" style="background-position: -168px -1064px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            146,
            119,
            110
        ]
    ],
    '388': [
        'Grotle',
        '/en/pokemon/388-grotle',
        '<span class="_p28" style="background-position: -196px -1064px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            181,
            157,
            143
        ]
    ],
    '389': [
        'Torterra',
        '/en/pokemon/389-torterra',
        '<span class="_p28" style="background-position: -224px -1064px;"></span>',
        '',
        [
            12,
            5
        ],
        [
            216,
            202,
            188
        ]
    ],
    '390': [
        'Chimchar',
        '/en/pokemon/390-chimchar',
        '<span class="_p28" style="background-position: 28px -1064px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            127,
            113,
            86
        ]
    ],
    '391': [
        'Monferno',
        '/en/pokemon/391-monferno',
        '<span class="_p28" style="background-position: 0px -1092px;"></span>',
        '',
        [
            10,
            2
        ],
        [
            162,
            158,
            105
        ]
    ],
    '392': [
        'Infernape',
        '/en/pokemon/392-infernape',
        '<span class="_p28" style="background-position: -28px -1092px;"></span>',
        '',
        [
            10,
            2
        ],
        [
            183,
            222,
            151
        ]
    ],
    '393': [
        'Piplup',
        '/en/pokemon/393-piplup',
        '<span class="_p28" style="background-position: -56px -1092px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            142,
            112,
            102
        ]
    ],
    '394': [
        'Prinplup',
        '/en/pokemon/394-prinplup',
        '<span class="_p28" style="background-position: -84px -1092px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            162,
            150,
            139
        ]
    ],
    '395': [
        'Empoleon',
        '/en/pokemon/395-empoleon',
        '<span class="_p28" style="background-position: -112px -1092px;"></span>',
        '',
        [
            11,
            9
        ],
        [
            197,
            210,
            186
        ]
    ],
    '396': [
        'Starly',
        '/en/pokemon/396-starly',
        '<span class="_p28" style="background-position: -140px -1092px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            120,
            101,
            58
        ]
    ],
    '397': [
        'Staravia',
        '/en/pokemon/397-staravia',
        '<span class="_p28" style="background-position: -168px -1092px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            146,
            142,
            94
        ]
    ],
    '398': [
        'Staraptor',
        '/en/pokemon/398-staraptor',
        '<span class="_p28" style="background-position: -196px -1092px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            198,
            234,
            140
        ]
    ],
    '399': [
        'Bidoof',
        '/en/pokemon/399-bidoof',
        '<span class="_p28" style="background-position: -224px -1092px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            153,
            80,
            73
        ]
    ],
    '400': [
        'Bibarel',
        '/en/pokemon/400-bibarel',
        '<span class="_p28" style="background-position: 28px -1092px;"></span>',
        '',
        [
            1,
            11
        ],
        [
            188,
            162,
            119
        ]
    ],
    '401': [
        'Kricketot',
        '/en/pokemon/401-kricketot',
        '<span class="_p28" style="background-position: 0px -1120px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            114,
            45,
            74
        ]
    ],
    '402': [
        'Kricketune',
        '/en/pokemon/402-kricketune',
        '<span class="_p28" style="background-position: -28px -1120px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            184,
            160,
            100
        ]
    ],
    '403': [
        'Shinx',
        '/en/pokemon/403-shinx',
        '<span class="_p28" style="background-position: -56px -1120px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            128,
            117,
            64
        ]
    ],
    '404': [
        'Luxio',
        '/en/pokemon/404-luxio',
        '<span class="_p28" style="background-position: -84px -1120px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            155,
            159,
            95
        ]
    ],
    '405': [
        'Luxray',
        '/en/pokemon/405-luxray',
        '<span class="_p28" style="background-position: -112px -1120px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            190,
            232,
            156
        ]
    ],
    '406': [
        'Budew',
        '/en/pokemon/406-budew',
        '<span class="_p28" style="background-position: -140px -1120px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            120,
            91,
            109
        ]
    ],
    '407': [
        'Roserade',
        '/en/pokemon/407-roserade',
        '<span class="_p28" style="background-position: -168px -1120px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            155,
            243,
            185
        ]
    ],
    '408': [
        'Cranidos',
        '/en/pokemon/408-cranidos',
        '<span class="_p28" style="background-position: -196px -1120px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            167,
            218,
            71
        ]
    ],
    '409': [
        'Rampardos',
        '/en/pokemon/409-rampardos',
        '<span class="_p28" style="background-position: -224px -1120px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            219,
            295,
            109
        ]
    ],
    '410': [
        'Shieldon',
        '/en/pokemon/410-shieldon',
        '<span class="_p28" style="background-position: 28px -1120px;"></span>',
        '',
        [
            6,
            9
        ],
        [
            102,
            76,
            195
        ]
    ],
    '411': [
        'Bastiodon',
        '/en/pokemon/411-bastiodon',
        '<span class="_p28" style="background-position: 0px -1148px;"></span>',
        '',
        [
            6,
            9
        ],
        [
            155,
            94,
            286
        ]
    ],
    '412': [
        'Burmy',
        '/en/pokemon/412-burmy',
        '<span class="_p28" style="background-position: -28px -1148px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            120,
            53,
            83
        ]
    ],
    '413': [
        'Wormadam',
        '/en/pokemon/413-wormadam',
        '<span class="_p28" style="background-position: -56px -1148px;"></span>',
        '',
        [
            7,
            12
        ],
        [
            155,
            141,
            180
        ]
    ],
    '414': [
        'Mothim',
        '/en/pokemon/414-mothim',
        '<span class="_p28" style="background-position: -84px -1148px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            172,
            185,
            98
        ]
    ],
    '415': [
        'Combee',
        '/en/pokemon/415-combee',
        '<span class="_p28" style="background-position: -112px -1148px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            102,
            59,
            83
        ]
    ],
    '416': [
        'Vespiquen',
        '/en/pokemon/416-vespiquen',
        '<span class="_p28" style="background-position: -140px -1148px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            172,
            149,
            190
        ]
    ],
    '417': [
        'Pachirisu',
        '/en/pokemon/417-pachirisu',
        '<span class="_p28" style="background-position: -168px -1148px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            155,
            94,
            172
        ]
    ],
    '418': [
        'Buizel',
        '/en/pokemon/418-buizel',
        '<span class="_p28" style="background-position: -196px -1148px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            146,
            132,
            67
        ]
    ],
    '419': [
        'Floatzel',
        '/en/pokemon/419-floatzel',
        '<span class="_p28" style="background-position: -224px -1148px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            198,
            221,
            114
        ]
    ],
    '420': [
        'Cherubi',
        '/en/pokemon/420-cherubi',
        '<span class="_p28" style="background-position: 28px -1148px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            128,
            108,
            92
        ]
    ],
    '421': [
        'Cherrim',
        '/en/pokemon/421-cherrim',
        '<span class="_p28" style="background-position: 0px -1176px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            172,
            170,
            153
        ]
    ],
    '422': [
        'Shellos',
        '/en/pokemon/422-shellos',
        '<span class="_p28" style="background-position: -28px -1176px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            183,
            103,
            105
        ]
    ],
    '423': [
        'Gastrodon',
        '/en/pokemon/423-gastrodon',
        '<span class="_p28" style="background-position: -56px -1176px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            244,
            169,
            143
        ]
    ],
    '424': [
        'Ambipom',
        '/en/pokemon/424-ambipom',
        '<span class="_p28" style="background-position: -84px -1176px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            181,
            205,
            143
        ]
    ],
    '425': [
        'Drifloon',
        '/en/pokemon/425-drifloon',
        '<span class="_p28" style="background-position: -112px -1176px;"></span>',
        '',
        [
            8,
            3
        ],
        [
            207,
            117,
            80
        ]
    ],
    '426': [
        'Drifblim',
        '/en/pokemon/426-drifblim',
        '<span class="_p28" style="background-position: -140px -1176px;"></span>',
        '',
        [
            8,
            3
        ],
        [
            312,
            180,
            102
        ]
    ],
    '427': [
        'Buneary',
        '/en/pokemon/427-buneary',
        '<span class="_p28" style="background-position: -168px -1176px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            146,
            130,
            105
        ]
    ],
    '428': [
        'Lopunny',
        '/en/pokemon/428-lopunny',
        '<span class="_p28" style="background-position: -196px -1176px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            163,
            156,
            194
        ]
    ],
    '429': [
        'Mismagius',
        '/en/pokemon/429-mismagius',
        '<span class="_p28" style="background-position: -224px -1176px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            155,
            211,
            187
        ]
    ],
    '430': [
        'Honchkrow',
        '/en/pokemon/430-honchkrow',
        '<span class="_p28" style="background-position: 28px -1176px;"></span>',
        '',
        [
            17,
            3
        ],
        [
            225,
            243,
            103
        ]
    ],
    '431': [
        'Glameow',
        '/en/pokemon/431-glameow',
        '<span class="_p28" style="background-position: 0px -1204px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            135,
            109,
            82
        ]
    ],
    '432': [
        'Purugly',
        '/en/pokemon/432-purugly',
        '<span class="_p28" style="background-position: -28px -1204px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            174,
            172,
            133
        ]
    ],
    '433': [
        'Chingling',
        '/en/pokemon/433-chingling',
        '<span class="_p28" style="background-position: -56px -1204px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            128,
            114,
            94
        ]
    ],
    '434': [
        'Stunky',
        '/en/pokemon/434-stunky',
        '<span class="_p28" style="background-position: -84px -1204px;"></span>',
        '',
        [
            4,
            17
        ],
        [
            160,
            121,
            90
        ]
    ],
    '435': [
        'Skuntank',
        '/en/pokemon/435-skuntank',
        '<span class="_p28" style="background-position: -112px -1204px;"></span>',
        '',
        [
            4,
            17
        ],
        [
            230,
            184,
            132
        ]
    ],
    '436': [
        'Bronzor',
        '/en/pokemon/436-bronzor',
        '<span class="_p28" style="background-position: -140px -1204px;"></span>',
        '',
        [
            9,
            14
        ],
        [
            149,
            43,
            154
        ]
    ],
    '437': [
        'Bronzong',
        '/en/pokemon/437-bronzong',
        '<span class="_p28" style="background-position: -168px -1204px;"></span>',
        '',
        [
            9,
            14
        ],
        [
            167,
            161,
            213
        ]
    ],
    '438': [
        'Bonsly',
        '/en/pokemon/438-bonsly',
        '<span class="_p28" style="background-position: -196px -1204px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            137,
            124,
            133
        ]
    ],
    '439': [
        'Mime Jr.',
        '/en/pokemon/439-mime-jr',
        '<span class="_p28" style="background-position: -224px -1204px;"></span>',
        '',
        [
            14,
            18
        ],
        [
            85,
            125,
            142
        ]
    ],
    '440': [
        'Happiny',
        '/en/pokemon/440-happiny',
        '<span class="_p28" style="background-position: 28px -1204px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            225,
            25,
            77
        ]
    ],
    '441': [
        'Chatot',
        '/en/pokemon/441-chatot',
        '<span class="_p28" style="background-position: 0px -1232px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            183,
            183,
            91
        ]
    ],
    '442': [
        'Spiritomb',
        '/en/pokemon/442-spiritomb',
        '<span class="_p28" style="background-position: -28px -1232px;"></span>',
        '',
        [
            8,
            17
        ],
        [
            137,
            169,
            199
        ]
    ],
    '443': [
        'Gible',
        '/en/pokemon/443-gible',
        '<span class="_p28" style="background-position: -56px -1232px;"></span>',
        '',
        [
            16,
            5
        ],
        [
            151,
            124,
            84
        ]
    ],
    '444': [
        'Gabite',
        '/en/pokemon/444-gabite',
        '<span class="_p28" style="background-position: -84px -1232px;"></span>',
        '',
        [
            16,
            5
        ],
        [
            169,
            172,
            125
        ]
    ],
    '445': [
        'Garchomp',
        '/en/pokemon/445-garchomp',
        '<span class="_p28" style="background-position: -112px -1232px;"></span>',
        '',
        [
            16,
            5
        ],
        [
            239,
            261,
            193
        ]
    ],
    '446': [
        'Munchlax',
        '/en/pokemon/446-munchlax',
        '<span class="_p28" style="background-position: -140px -1232px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            286,
            137,
            117
        ]
    ],
    '447': [
        'Riolu',
        '/en/pokemon/447-riolu',
        '<span class="_p28" style="background-position: -168px -1232px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            120,
            127,
            78
        ]
    ],
    '448': [
        'Lucario',
        '/en/pokemon/448-lucario',
        '<span class="_p28" style="background-position: -196px -1232px;"></span>',
        '',
        [
            2,
            9
        ],
        [
            172,
            236,
            144
        ]
    ],
    '449': [
        'Hippopotas',
        '/en/pokemon/449-hippopotas',
        '<span class="_p28" style="background-position: -224px -1232px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            169,
            124,
            118
        ]
    ],
    '450': [
        'Hippowdon',
        '/en/pokemon/450-hippowdon',
        '<span class="_p28" style="background-position: 28px -1232px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            239,
            201,
            191
        ]
    ],
    '451': [
        'Skorupi',
        '/en/pokemon/451-skorupi',
        '<span class="_p28" style="background-position: 0px -1260px;"></span>',
        '',
        [
            4,
            7
        ],
        [
            120,
            93,
            151
        ]
    ],
    '452': [
        'Drapion',
        '/en/pokemon/452-drapion',
        '<span class="_p28" style="background-position: -28px -1260px;"></span>',
        '',
        [
            4,
            17
        ],
        [
            172,
            180,
            202
        ]
    ],
    '453': [
        'Croagunk',
        '/en/pokemon/453-croagunk',
        '<span class="_p28" style="background-position: -56px -1260px;"></span>',
        '',
        [
            4,
            2
        ],
        [
            134,
            116,
            76
        ]
    ],
    '454': [
        'Toxicroak',
        '/en/pokemon/454-toxicroak',
        '<span class="_p28" style="background-position: -84px -1260px;"></span>',
        '',
        [
            4,
            2
        ],
        [
            195,
            211,
            133
        ]
    ],
    '455': [
        'Carnivine',
        '/en/pokemon/455-carnivine',
        '<span class="_p28" style="background-position: -112px -1260px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            179,
            187,
            136
        ]
    ],
    '456': [
        'Finneon',
        '/en/pokemon/456-finneon',
        '<span class="_p28" style="background-position: -140px -1260px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            135,
            96,
            116
        ]
    ],
    '457': [
        'Lumineon',
        '/en/pokemon/457-lumineon',
        '<span class="_p28" style="background-position: -168px -1260px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            170,
            142,
            170
        ]
    ],
    '458': [
        'Mantyke',
        '/en/pokemon/458-mantyke',
        '<span class="_p28" style="background-position: -196px -1260px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            128,
            105,
            179
        ]
    ],
    '459': [
        'Snover',
        '/en/pokemon/459-snover',
        '<span class="_p28" style="background-position: -224px -1260px;"></span>',
        '',
        [
            12,
            15
        ],
        [
            155,
            115,
            105
        ]
    ],
    '460': [
        'Abomasnow',
        '/en/pokemon/460-abomasnow',
        '<span class="_p28" style="background-position: 28px -1260px;"></span>',
        '',
        [
            12,
            15
        ],
        [
            207,
            178,
            158
        ]
    ],
    '461': [
        'Weavile',
        '/en/pokemon/461-weavile',
        '<span class="_p28" style="background-position: 0px -1288px;"></span>',
        '',
        [
            17,
            15
        ],
        [
            172,
            243,
            171
        ]
    ],
    '462': [
        'Magnezone',
        '/en/pokemon/462-magnezone',
        '<span class="_p28" style="background-position: -28px -1288px;"></span>',
        '',
        [
            13,
            9
        ],
        [
            172,
            238,
            205
        ]
    ],
    '463': [
        'Lickilicky',
        '/en/pokemon/463-lickilicky',
        '<span class="_p28" style="background-position: -56px -1288px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            242,
            161,
            181
        ]
    ],
    '464': [
        'Rhyperior',
        '/en/pokemon/464-rhyperior',
        '<span class="_p28" style="background-position: -84px -1288px;"></span>',
        '',
        [
            5,
            6
        ],
        [
            251,
            241,
            190
        ]
    ],
    '465': [
        'Tangrowth',
        '/en/pokemon/465-tangrowth',
        '<span class="_p28" style="background-position: -112px -1288px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            225,
            207,
            184
        ]
    ],
    '466': [
        'Electivire',
        '/en/pokemon/466-electivire',
        '<span class="_p28" style="background-position: -140px -1288px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            181,
            249,
            163
        ]
    ],
    '467': [
        'Magmortar',
        '/en/pokemon/467-magmortar',
        '<span class="_p28" style="background-position: -168px -1288px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            181,
            247,
            172
        ]
    ],
    '468': [
        'Togekiss',
        '/en/pokemon/468-togekiss',
        '<span class="_p28" style="background-position: -196px -1288px;"></span>',
        '',
        [
            18,
            3
        ],
        [
            198,
            225,
            217
        ]
    ],
    '469': [
        'Yanmega',
        '/en/pokemon/469-yanmega',
        '<span class="_p28" style="background-position: -224px -1288px;"></span>',
        '',
        [
            7,
            3
        ],
        [
            200,
            231,
            156
        ]
    ],
    '470': [
        'Leafeon',
        '/en/pokemon/470-leafeon',
        '<span class="_p28" style="background-position: 28px -1288px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            163,
            216,
            219
        ]
    ],
    '471': [
        'Glaceon',
        '/en/pokemon/471-glaceon',
        '<span class="_p28" style="background-position: 0px -1316px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            163,
            238,
            205
        ]
    ],
    '472': [
        'Gliscor',
        '/en/pokemon/472-gliscor',
        '<span class="_p28" style="background-position: -28px -1316px;"></span>',
        '',
        [
            5,
            3
        ],
        [
            181,
            185,
            222
        ]
    ],
    '473': [
        'Mamoswine',
        '/en/pokemon/473-mamoswine',
        '<span class="_p28" style="background-position: -56px -1316px;"></span>',
        '',
        [
            15,
            5
        ],
        [
            242,
            247,
            146
        ]
    ],
    '474': [
        'Porygon-Z',
        '/en/pokemon/474-porygon-z',
        '<span class="_p28" style="background-position: -84px -1316px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            198,
            264,
            150
        ]
    ],
    '475': [
        'Gallade',
        '/en/pokemon/475-gallade',
        '<span class="_p28" style="background-position: -112px -1316px;"></span>',
        '',
        [
            14,
            2
        ],
        [
            169,
            237,
            195
        ]
    ],
    '476': [
        'Probopass',
        '/en/pokemon/476-probopass',
        '<span class="_p28" style="background-position: -140px -1316px;"></span>',
        '',
        [
            6,
            9
        ],
        [
            155,
            135,
            275
        ]
    ],
    '477': [
        'Dusknoir',
        '/en/pokemon/477-dusknoir',
        '<span class="_p28" style="background-position: -168px -1316px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            128,
            180,
            254
        ]
    ],
    '478': [
        'Froslass',
        '/en/pokemon/478-froslass',
        '<span class="_p28" style="background-position: -196px -1316px;"></span>',
        '',
        [
            15,
            8
        ],
        [
            172,
            171,
            150
        ]
    ],
    '479': [
        'Rotom',
        '/en/pokemon/479-rotom',
        '<span class="_p28" style="background-position: -224px -1316px;"></span>',
        '',
        [
            13,
            8
        ],
        [
            137,
            185,
            159
        ]
    ],
    '480': [
        'Uxie',
        '/en/pokemon/480-uxie',
        '<span class="_p28" style="background-position: 28px -1316px;"></span>',
        ' p-legendary',
        [
            14,
            null
        ],
        [
            181,
            156,
            270
        ]
    ],
    '481': [
        'Mesprit',
        '/en/pokemon/481-mesprit',
        '<span class="_p28" style="background-position: 0px -1344px;"></span>',
        ' p-legendary',
        [
            14,
            null
        ],
        [
            190,
            212,
            212
        ]
    ],
    '482': [
        'Azelf',
        '/en/pokemon/482-azelf',
        '<span class="_p28" style="background-position: -28px -1344px;"></span>',
        ' p-legendary',
        [
            14,
            null
        ],
        [
            181,
            270,
            151
        ]
    ],
    '483': [
        'Dialga',
        '/en/pokemon/483-dialga',
        '<span class="_p28" style="background-position: -56px -1344px;"></span>',
        ' p-legendary',
        [
            9,
            16
        ],
        [
            205,
            275,
            211
        ]
    ],
    '484': [
        'Palkia',
        '/en/pokemon/484-palkia',
        '<span class="_p28" style="background-position: -84px -1344px;"></span>',
        ' p-legendary',
        [
            11,
            16
        ],
        [
            189,
            280,
            215
        ]
    ],
    '485': [
        'Heatran',
        '/en/pokemon/485-heatran',
        '<span class="_p28" style="background-position: -112px -1344px;"></span>',
        ' p-legendary',
        [
            10,
            9
        ],
        [
            209,
            251,
            213
        ]
    ],
    '486': [
        'Regigigas',
        '/en/pokemon/486-regigigas',
        '<span class="_p28" style="background-position: -140px -1344px;"></span>',
        ' p-legendary',
        [
            1,
            null
        ],
        [
            221,
            287,
            210
        ]
    ],
    '487': [
        'Giratina',
        '/en/pokemon/487-giratina',
        '<span class="_p28" style="background-position: -168px -1344px;"></span>',
        ' p-legendary',
        [
            8,
            16
        ],
        [
            284,
            187,
            225
        ]
    ],
    '488': [
        'Cresselia',
        '/en/pokemon/488-cresselia',
        '<span class="_p28" style="background-position: -196px -1344px;"></span>',
        ' p-legendary',
        [
            14,
            null
        ],
        [
            260,
            152,
            258
        ]
    ],
    '489': [
        'Phione',
        '/en/pokemon/489-phione',
        '<span class="_p28" style="background-position: -224px -1344px;"></span>',
        ' p-mythical',
        [
            11,
            null
        ],
        [
            190,
            162,
            162
        ]
    ],
    '490': [
        'Manaphy',
        '/en/pokemon/490-manaphy',
        '<span class="_p28" style="background-position: 28px -1344px;"></span>',
        ' p-mythical',
        [
            11,
            null
        ],
        [
            225,
            210,
            210
        ]
    ],
    '491': [
        'Darkrai',
        '/en/pokemon/491-darkrai',
        '<span class="_p28" style="background-position: 0px -1372px;"></span>',
        ' p-mythical',
        [
            17,
            null
        ],
        [
            172,
            285,
            198
        ]
    ],
    '492': [
        'Shaymin',
        '/en/pokemon/492-shaymin',
        '<span class="_p28" style="background-position: -28px -1372px;"></span>',
        ' p-mythical',
        [
            12,
            null
        ],
        [
            225,
            210,
            210
        ]
    ],
    '493': [
        'Arceus',
        '/en/pokemon/493-arceus',
        '<span class="_p28" style="background-position: -56px -1372px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            237,
            238,
            238
        ]
    ],
    '494': [
        'Victini',
        '/en/pokemon/494-victini',
        '<span class="_p28" style="background-position: -84px -1372px;"></span>',
        '',
        [
            14,
            10
        ],
        [
            225,
            210,
            210
        ]
    ],
    '495': [
        'Snivy',
        '/en/pokemon/495-snivy',
        '<span class="_p28" style="background-position: -112px -1372px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            128,
            88,
            107
        ]
    ],
    '496': [
        'Servine',
        '/en/pokemon/496-servine',
        '<span class="_p28" style="background-position: -140px -1372px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            155,
            122,
            152
        ]
    ],
    '497': [
        'Serperior',
        '/en/pokemon/497-serperior',
        '<span class="_p28" style="background-position: -168px -1372px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            181,
            161,
            204
        ]
    ],
    '498': [
        'Tepig',
        '/en/pokemon/498-tepig',
        '<span class="_p28" style="background-position: -196px -1372px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            163,
            115,
            85
        ]
    ],
    '499': [
        'Pignite',
        '/en/pokemon/499-pignite',
        '<span class="_p28" style="background-position: -224px -1372px;"></span>',
        '',
        [
            10,
            2
        ],
        [
            207,
            173,
            106
        ]
    ],
    '500': [
        'Emboar',
        '/en/pokemon/500-emboar',
        '<span class="_p28" style="background-position: 28px -1372px;"></span>',
        '',
        [
            10,
            2
        ],
        [
            242,
            235,
            127
        ]
    ],
    '501': [
        'Oshawott',
        '/en/pokemon/501-oshawott',
        '<span class="_p28" style="background-position: 0px -1400px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            146,
            117,
            85
        ]
    ],
    '502': [
        'Dewott',
        '/en/pokemon/502-dewott',
        '<span class="_p28" style="background-position: -28px -1400px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            181,
            159,
            116
        ]
    ],
    '503': [
        'Samurott',
        '/en/pokemon/503-samurott',
        '<span class="_p28" style="background-position: -56px -1400px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            216,
            212,
            157
        ]
    ],
    '504': [
        'Patrat',
        '/en/pokemon/504-patrat',
        '<span class="_p28" style="background-position: -84px -1400px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            128,
            98,
            73
        ]
    ],
    '505': [
        'Watchog',
        '/en/pokemon/505-watchog',
        '<span class="_p28" style="background-position: -112px -1400px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            155,
            165,
            139
        ]
    ],
    '506': [
        'Lillipup',
        '/en/pokemon/506-lillipup',
        '<span class="_p28" style="background-position: -140px -1400px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            128,
            107,
            86
        ]
    ],
    '507': [
        'Herdier',
        '/en/pokemon/507-herdier',
        '<span class="_p28" style="background-position: -168px -1400px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            163,
            145,
            126
        ]
    ],
    '508': [
        'Stoutland',
        '/en/pokemon/508-stoutland',
        '<span class="_p28" style="background-position: -196px -1400px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            198,
            206,
            182
        ]
    ],
    '509': [
        'Purrloin',
        '/en/pokemon/509-purrloin',
        '<span class="_p28" style="background-position: -224px -1400px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            121,
            98,
            73
        ]
    ],
    '510': [
        'Liepard',
        '/en/pokemon/510-liepard',
        '<span class="_p28" style="background-position: 28px -1400px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            162,
            187,
            106
        ]
    ],
    '511': [
        'Pansage',
        '/en/pokemon/511-pansage',
        '<span class="_p28" style="background-position: 0px -1428px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            137,
            104,
            94
        ]
    ],
    '512': [
        'Simisage',
        '/en/pokemon/512-simisage',
        '<span class="_p28" style="background-position: -28px -1428px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            181,
            206,
            133
        ]
    ],
    '513': [
        'Pansear',
        '/en/pokemon/513-pansear',
        '<span class="_p28" style="background-position: -56px -1428px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            137,
            104,
            94
        ]
    ],
    '514': [
        'Simisear',
        '/en/pokemon/514-simisear',
        '<span class="_p28" style="background-position: -84px -1428px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            181,
            206,
            133
        ]
    ],
    '515': [
        'Panpour',
        '/en/pokemon/515-panpour',
        '<span class="_p28" style="background-position: -112px -1428px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            137,
            104,
            94
        ]
    ],
    '516': [
        'Simipour',
        '/en/pokemon/516-simipour',
        '<span class="_p28" style="background-position: -140px -1428px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            181,
            206,
            133
        ]
    ],
    '517': [
        'Munna',
        '/en/pokemon/517-munna',
        '<span class="_p28" style="background-position: -168px -1428px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            183,
            111,
            92
        ]
    ],
    '518': [
        'Musharna',
        '/en/pokemon/518-musharna',
        '<span class="_p28" style="background-position: -196px -1428px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            253,
            183,
            166
        ]
    ],
    '519': [
        'Pidove',
        '/en/pokemon/519-pidove',
        '<span class="_p28" style="background-position: -224px -1428px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            137,
            98,
            80
        ]
    ],
    '520': [
        'Tranquill',
        '/en/pokemon/520-tranquill',
        '<span class="_p28" style="background-position: 28px -1428px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            158,
            144,
            107
        ]
    ],
    '521': [
        'Unfezant',
        '/en/pokemon/521-unfezant',
        '<span class="_p28" style="background-position: 0px -1456px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            190,
            226,
            146
        ]
    ],
    '522': [
        'Blitzle',
        '/en/pokemon/522-blitzle',
        '<span class="_p28" style="background-position: -28px -1456px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            128,
            118,
            64
        ]
    ],
    '523': [
        'Zebstrika',
        '/en/pokemon/523-zebstrika',
        '<span class="_p28" style="background-position: -56px -1456px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            181,
            211,
            136
        ]
    ],
    '524': [
        'Roggenrola',
        '/en/pokemon/524-roggenrola',
        '<span class="_p28" style="background-position: -84px -1456px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            146,
            121,
            110
        ]
    ],
    '525': [
        'Boldore',
        '/en/pokemon/525-boldore',
        '<span class="_p28" style="background-position: -112px -1456px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            172,
            174,
            143
        ]
    ],
    '526': [
        'Gigalith',
        '/en/pokemon/526-gigalith',
        '<span class="_p28" style="background-position: -140px -1456px;"></span>',
        '',
        [
            6,
            null
        ],
        [
            198,
            226,
            201
        ]
    ],
    '527': [
        'Woobat',
        '/en/pokemon/527-woobat',
        '<span class="_p28" style="background-position: -168px -1456px;"></span>',
        '',
        [
            14,
            3
        ],
        [
            163,
            107,
            85
        ]
    ],
    '528': [
        'Swoobat',
        '/en/pokemon/528-swoobat',
        '<span class="_p28" style="background-position: -196px -1456px;"></span>',
        '',
        [
            14,
            3
        ],
        [
            167,
            161,
            119
        ]
    ],
    '529': [
        'Drilbur',
        '/en/pokemon/529-drilbur',
        '<span class="_p28" style="background-position: -224px -1456px;"></span>',
        '',
        [
            5,
            null
        ],
        [
            155,
            154,
            85
        ]
    ],
    '530': [
        'Excadrill',
        '/en/pokemon/530-excadrill',
        '<span class="_p28" style="background-position: 28px -1456px;"></span>',
        '',
        [
            5,
            9
        ],
        [
            242,
            255,
            129
        ]
    ],
    '531': [
        'Audino',
        '/en/pokemon/531-audino',
        '<span class="_p28" style="background-position: 0px -1484px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            230,
            114,
            163
        ]
    ],
    '532': [
        'Timburr',
        '/en/pokemon/532-timburr',
        '<span class="_p28" style="background-position: -28px -1484px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            181,
            134,
            87
        ]
    ],
    '533': [
        'Gurdurr',
        '/en/pokemon/533-gurdurr',
        '<span class="_p28" style="background-position: -56px -1484px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            198,
            180,
            134
        ]
    ],
    '534': [
        'Conkeldurr',
        '/en/pokemon/534-conkeldurr',
        '<span class="_p28" style="background-position: -84px -1484px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            233,
            243,
            158
        ]
    ],
    '535': [
        'Tympole',
        '/en/pokemon/535-tympole',
        '<span class="_p28" style="background-position: -112px -1484px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            137,
            98,
            78
        ]
    ],
    '536': [
        'Palpitoad',
        '/en/pokemon/536-palpitoad',
        '<span class="_p28" style="background-position: -140px -1484px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            181,
            128,
            109
        ]
    ],
    '537': [
        'Seismitoad',
        '/en/pokemon/537-seismitoad',
        '<span class="_p28" style="background-position: -168px -1484px;"></span>',
        '',
        [
            11,
            5
        ],
        [
            233,
            188,
            150
        ]
    ],
    '538': [
        'Throh',
        '/en/pokemon/538-throh',
        '<span class="_p28" style="background-position: -196px -1484px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            260,
            172,
            160
        ]
    ],
    '539': [
        'Sawk',
        '/en/pokemon/539-sawk',
        '<span class="_p28" style="background-position: -224px -1484px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            181,
            231,
            153
        ]
    ],
    '540': [
        'Sewaddle',
        '/en/pokemon/540-sewaddle',
        '<span class="_p28" style="background-position: 28px -1484px;"></span>',
        '',
        [
            7,
            12
        ],
        [
            128,
            96,
            124
        ]
    ],
    '541': [
        'Swadloon',
        '/en/pokemon/541-swadloon',
        '<span class="_p28" style="background-position: 0px -1512px;"></span>',
        '',
        [
            7,
            12
        ],
        [
            146,
            115,
            162
        ]
    ],
    '542': [
        'Leavanny',
        '/en/pokemon/542-leavanny',
        '<span class="_p28" style="background-position: -28px -1512px;"></span>',
        '',
        [
            7,
            12
        ],
        [
            181,
            205,
            165
        ]
    ],
    '543': [
        'Venipede',
        '/en/pokemon/543-venipede',
        '<span class="_p28" style="background-position: -56px -1512px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            102,
            83,
            99
        ]
    ],
    '544': [
        'Whirlipede',
        '/en/pokemon/544-whirlipede',
        '<span class="_p28" style="background-position: -84px -1512px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            120,
            100,
            173
        ]
    ],
    '545': [
        'Scolipede',
        '/en/pokemon/545-scolipede',
        '<span class="_p28" style="background-position: -112px -1512px;"></span>',
        '',
        [
            7,
            4
        ],
        [
            155,
            203,
            175
        ]
    ],
    '546': [
        'Cottonee',
        '/en/pokemon/546-cottonee',
        '<span class="_p28" style="background-position: -140px -1512px;"></span>',
        '',
        [
            12,
            18
        ],
        [
            120,
            71,
            111
        ]
    ],
    '547': [
        'Whimsicott',
        '/en/pokemon/547-whimsicott',
        '<span class="_p28" style="background-position: -168px -1512px;"></span>',
        '',
        [
            12,
            18
        ],
        [
            155,
            164,
            176
        ]
    ],
    '548': [
        'Petilil',
        '/en/pokemon/548-petilil',
        '<span class="_p28" style="background-position: -196px -1512px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            128,
            119,
            91
        ]
    ],
    '549': [
        'Lilligant',
        '/en/pokemon/549-lilligant',
        '<span class="_p28" style="background-position: -224px -1512px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            172,
            214,
            155
        ]
    ],
    '550': [
        'Basculin',
        '/en/pokemon/550-basculin',
        '<span class="_p28" style="background-position: 28px -1512px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            172,
            189,
            129
        ]
    ],
    '551': [
        'Sandile',
        '/en/pokemon/551-sandile',
        '<span class="_p28" style="background-position: 0px -1540px;"></span>',
        '',
        [
            5,
            17
        ],
        [
            137,
            132,
            69
        ]
    ],
    '552': [
        'Krokorok',
        '/en/pokemon/552-krokorok',
        '<span class="_p28" style="background-position: -28px -1540px;"></span>',
        '',
        [
            5,
            17
        ],
        [
            155,
            155,
            90
        ]
    ],
    '553': [
        'Krookodile',
        '/en/pokemon/553-krookodile',
        '<span class="_p28" style="background-position: -56px -1540px;"></span>',
        '',
        [
            5,
            17
        ],
        [
            216,
            229,
            158
        ]
    ],
    '554': [
        'Darumaka',
        '/en/pokemon/554-darumaka',
        '<span class="_p28" style="background-position: -84px -1540px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            172,
            153,
            86
        ]
    ],
    '555': [
        'Darmanitan',
        '/en/pokemon/555-darmanitan',
        '<span class="_p28" style="background-position: -112px -1540px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            233,
            263,
            114
        ]
    ],
    '556': [
        'Maractus',
        '/en/pokemon/556-maractus',
        '<span class="_p28" style="background-position: -140px -1540px;"></span>',
        '',
        [
            12,
            null
        ],
        [
            181,
            201,
            130
        ]
    ],
    '557': [
        'Dwebble',
        '/en/pokemon/557-dwebble',
        '<span class="_p28" style="background-position: -168px -1540px;"></span>',
        '',
        [
            7,
            6
        ],
        [
            137,
            118,
            128
        ]
    ],
    '558': [
        'Crustle',
        '/en/pokemon/558-crustle',
        '<span class="_p28" style="background-position: -196px -1540px;"></span>',
        '',
        [
            7,
            6
        ],
        [
            172,
            188,
            200
        ]
    ],
    '559': [
        'Scraggy',
        '/en/pokemon/559-scraggy',
        '<span class="_p28" style="background-position: -224px -1540px;"></span>',
        '',
        [
            17,
            2
        ],
        [
            137,
            132,
            132
        ]
    ],
    '560': [
        'Scrafty',
        '/en/pokemon/560-scrafty',
        '<span class="_p28" style="background-position: 28px -1540px;"></span>',
        '',
        [
            17,
            2
        ],
        [
            163,
            163,
            222
        ]
    ],
    '561': [
        'Sigilyph',
        '/en/pokemon/561-sigilyph',
        '<span class="_p28" style="background-position: 0px -1568px;"></span>',
        '',
        [
            14,
            3
        ],
        [
            176,
            204,
            167
        ]
    ],
    '562': [
        'Yamask',
        '/en/pokemon/562-yamask',
        '<span class="_p28" style="background-position: -28px -1568px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            116,
            95,
            141
        ]
    ],
    '563': [
        'Cofagrigus',
        '/en/pokemon/563-cofagrigus',
        '<span class="_p28" style="background-position: -56px -1568px;"></span>',
        '',
        [
            8,
            null
        ],
        [
            151,
            163,
            237
        ]
    ],
    '564': [
        'Tirtouga',
        '/en/pokemon/564-tirtouga',
        '<span class="_p28" style="background-position: -84px -1568px;"></span>',
        '',
        [
            11,
            6
        ],
        [
            144,
            134,
            146
        ]
    ],
    '565': [
        'Carracosta',
        '/en/pokemon/565-carracosta',
        '<span class="_p28" style="background-position: -112px -1568px;"></span>',
        '',
        [
            11,
            6
        ],
        [
            179,
            192,
            197
        ]
    ],
    '566': [
        'Archen',
        '/en/pokemon/566-archen',
        '<span class="_p28" style="background-position: -140px -1568px;"></span>',
        '',
        [
            6,
            3
        ],
        [
            146,
            213,
            89
        ]
    ],
    '567': [
        'Archeops',
        '/en/pokemon/567-archeops',
        '<span class="_p28" style="background-position: -168px -1568px;"></span>',
        '',
        [
            6,
            3
        ],
        [
            181,
            292,
            139
        ]
    ],
    '568': [
        'Trubbish',
        '/en/pokemon/568-trubbish',
        '<span class="_p28" style="background-position: -196px -1568px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            137,
            96,
            122
        ]
    ],
    '569': [
        'Garbodor',
        '/en/pokemon/569-garbodor',
        '<span class="_p28" style="background-position: -224px -1568px;"></span>',
        '',
        [
            4,
            null
        ],
        [
            190,
            181,
            164
        ]
    ],
    '570': [
        'Zorua',
        '/en/pokemon/570-zorua',
        '<span class="_p28" style="background-position: 28px -1568px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            120,
            153,
            78
        ]
    ],
    '571': [
        'Zoroark',
        '/en/pokemon/571-zoroark',
        '<span class="_p28" style="background-position: 0px -1596px;"></span>',
        '',
        [
            17,
            null
        ],
        [
            155,
            250,
            127
        ]
    ],
    '572': [
        'Minccino',
        '/en/pokemon/572-minccino',
        '<span class="_p28" style="background-position: -28px -1596px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            146,
            98,
            80
        ]
    ],
    '573': [
        'Cinccino',
        '/en/pokemon/573-cinccino',
        '<span class="_p28" style="background-position: -56px -1596px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            181,
            198,
            130
        ]
    ],
    '574': [
        'Gothita',
        '/en/pokemon/574-gothita',
        '<span class="_p28" style="background-position: -84px -1596px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            128,
            98,
            112
        ]
    ],
    '575': [
        'Gothorita',
        '/en/pokemon/575-gothorita',
        '<span class="_p28" style="background-position: -112px -1596px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            155,
            137,
            153
        ]
    ],
    '576': [
        'Gothitelle',
        '/en/pokemon/576-gothitelle',
        '<span class="_p28" style="background-position: -140px -1596px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            172,
            176,
            205
        ]
    ],
    '577': [
        'Solosis',
        '/en/pokemon/577-solosis',
        '<span class="_p28" style="background-position: -168px -1596px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            128,
            170,
            83
        ]
    ],
    '578': [
        'Duosion',
        '/en/pokemon/578-duosion',
        '<span class="_p28" style="background-position: -196px -1596px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            163,
            208,
            103
        ]
    ],
    '579': [
        'Reuniclus',
        '/en/pokemon/579-reuniclus',
        '<span class="_p28" style="background-position: -224px -1596px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            242,
            214,
            148
        ]
    ],
    '580': [
        'Ducklett',
        '/en/pokemon/580-ducklett',
        '<span class="_p28" style="background-position: 28px -1596px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            158,
            84,
            96
        ]
    ],
    '581': [
        'Swanna',
        '/en/pokemon/581-swanna',
        '<span class="_p28" style="background-position: 0px -1624px;"></span>',
        '',
        [
            11,
            3
        ],
        [
            181,
            182,
            132
        ]
    ],
    '582': [
        'Vanillite',
        '/en/pokemon/582-vanillite',
        '<span class="_p28" style="background-position: -28px -1624px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            113,
            118,
            106
        ]
    ],
    '583': [
        'Vanillish',
        '/en/pokemon/583-vanillish',
        '<span class="_p28" style="background-position: -56px -1624px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            139,
            151,
            138
        ]
    ],
    '584': [
        'Vanilluxe',
        '/en/pokemon/584-vanilluxe',
        '<span class="_p28" style="background-position: -84px -1624px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            174,
            218,
            184
        ]
    ],
    '585': [
        'Deerling',
        '/en/pokemon/585-deerling',
        '<span class="_p28" style="background-position: -112px -1624px;"></span>',
        '',
        [
            1,
            12
        ],
        [
            155,
            115,
            100
        ]
    ],
    '586': [
        'Sawsbuck',
        '/en/pokemon/586-sawsbuck',
        '<span class="_p28" style="background-position: -140px -1624px;"></span>',
        '',
        [
            1,
            12
        ],
        [
            190,
            198,
            146
        ]
    ],
    '587': [
        'Emolga',
        '/en/pokemon/587-emolga',
        '<span class="_p28" style="background-position: -168px -1624px;"></span>',
        '',
        [
            13,
            3
        ],
        [
            146,
            158,
            127
        ]
    ],
    '588': [
        'Karrablast',
        '/en/pokemon/588-karrablast',
        '<span class="_p28" style="background-position: -196px -1624px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            137,
            137,
            87
        ]
    ],
    '589': [
        'Escavalier',
        '/en/pokemon/589-escavalier',
        '<span class="_p28" style="background-position: -224px -1624px;"></span>',
        '',
        [
            7,
            9
        ],
        [
            172,
            223,
            187
        ]
    ],
    '590': [
        'Foongus',
        '/en/pokemon/590-foongus',
        '<span class="_p28" style="background-position: 28px -1624px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            170,
            97,
            91
        ]
    ],
    '591': [
        'Amoonguss',
        '/en/pokemon/591-amoonguss',
        '<span class="_p28" style="background-position: 0px -1652px;"></span>',
        '',
        [
            12,
            4
        ],
        [
            249,
            155,
            139
        ]
    ],
    '592': [
        'Frillish',
        '/en/pokemon/592-frillish',
        '<span class="_p28" style="background-position: -28px -1652px;"></span>',
        '',
        [
            11,
            8
        ],
        [
            146,
            115,
            134
        ]
    ],
    '593': [
        'Jellicent',
        '/en/pokemon/593-jellicent',
        '<span class="_p28" style="background-position: -56px -1652px;"></span>',
        '',
        [
            11,
            8
        ],
        [
            225,
            159,
            178
        ]
    ],
    '594': [
        'Alomomola',
        '/en/pokemon/594-alomomola',
        '<span class="_p28" style="background-position: -84px -1652px;"></span>',
        '',
        [
            11,
            null
        ],
        [
            338,
            138,
            131
        ]
    ],
    '595': [
        'Joltik',
        '/en/pokemon/595-joltik',
        '<span class="_p28" style="background-position: -112px -1652px;"></span>',
        '',
        [
            7,
            13
        ],
        [
            137,
            110,
            98
        ]
    ],
    '596': [
        'Galvantula',
        '/en/pokemon/596-galvantula',
        '<span class="_p28" style="background-position: -140px -1652px;"></span>',
        '',
        [
            7,
            13
        ],
        [
            172,
            201,
            128
        ]
    ],
    '597': [
        'Ferroseed',
        '/en/pokemon/597-ferroseed',
        '<span class="_p28" style="background-position: -168px -1652px;"></span>',
        '',
        [
            12,
            9
        ],
        [
            127,
            82,
            155
        ]
    ],
    '598': [
        'Ferrothorn',
        '/en/pokemon/598-ferrothorn',
        '<span class="_p28" style="background-position: -196px -1652px;"></span>',
        '',
        [
            12,
            9
        ],
        [
            179,
            158,
            223
        ]
    ],
    '599': [
        'Klink',
        '/en/pokemon/599-klink',
        '<span class="_p28" style="background-position: -224px -1652px;"></span>',
        '',
        [
            9,
            null
        ],
        [
            120,
            98,
            121
        ]
    ],
    '600': [
        'Klang',
        '/en/pokemon/600-klang',
        '<span class="_p28" style="background-position: 28px -1652px;"></span>',
        '',
        [
            9,
            null
        ],
        [
            155,
            150,
            174
        ]
    ],
    '601': [
        'Klinklang',
        '/en/pokemon/601-klinklang',
        '<span class="_p28" style="background-position: 0px -1680px;"></span>',
        '',
        [
            9,
            null
        ],
        [
            155,
            199,
            214
        ]
    ],
    '602': [
        'Tynamo',
        '/en/pokemon/602-tynamo',
        '<span class="_p28" style="background-position: -28px -1680px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            111,
            105,
            78
        ]
    ],
    '603': [
        'Eelektrik',
        '/en/pokemon/603-eelektrik',
        '<span class="_p28" style="background-position: -56px -1680px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            163,
            156,
            130
        ]
    ],
    '604': [
        'Eelektross',
        '/en/pokemon/604-eelektross',
        '<span class="_p28" style="background-position: -84px -1680px;"></span>',
        '',
        [
            13,
            null
        ],
        [
            198,
            217,
            152
        ]
    ],
    '605': [
        'Elgyem',
        '/en/pokemon/605-elgyem',
        '<span class="_p28" style="background-position: -112px -1680px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            146,
            148,
            100
        ]
    ],
    '606': [
        'Beheeyem',
        '/en/pokemon/606-beheeyem',
        '<span class="_p28" style="background-position: -140px -1680px;"></span>',
        '',
        [
            14,
            null
        ],
        [
            181,
            221,
            163
        ]
    ],
    '607': [
        'Litwick',
        '/en/pokemon/607-litwick',
        '<span class="_p28" style="background-position: -168px -1680px;"></span>',
        '',
        [
            8,
            10
        ],
        [
            137,
            108,
            98
        ]
    ],
    '608': [
        'Lampent',
        '/en/pokemon/608-lampent',
        '<span class="_p28" style="background-position: -196px -1680px;"></span>',
        '',
        [
            8,
            10
        ],
        [
            155,
            169,
            115
        ]
    ],
    '609': [
        'Chandelure',
        '/en/pokemon/609-chandelure',
        '<span class="_p28" style="background-position: -224px -1680px;"></span>',
        '',
        [
            8,
            10
        ],
        [
            155,
            271,
            182
        ]
    ],
    '610': [
        'Axew',
        '/en/pokemon/610-axew',
        '<span class="_p28" style="background-position: 28px -1680px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            130,
            154,
            101
        ]
    ],
    '611': [
        'Fraxure',
        '/en/pokemon/611-fraxure',
        '<span class="_p28" style="background-position: 0px -1708px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            165,
            212,
            123
        ]
    ],
    '612': [
        'Haxorus',
        '/en/pokemon/612-haxorus',
        '<span class="_p28" style="background-position: -28px -1708px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            183,
            284,
            172
        ]
    ],
    '613': [
        'Cubchoo',
        '/en/pokemon/613-cubchoo',
        '<span class="_p28" style="background-position: -56px -1708px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            146,
            128,
            74
        ]
    ],
    '614': [
        'Beartic',
        '/en/pokemon/614-beartic',
        '<span class="_p28" style="background-position: -84px -1708px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            216,
            233,
            152
        ]
    ],
    '615': [
        'Cryogonal',
        '/en/pokemon/615-cryogonal',
        '<span class="_p28" style="background-position: -112px -1708px;"></span>',
        '',
        [
            15,
            null
        ],
        [
            190,
            190,
            218
        ]
    ],
    '616': [
        'Shelmet',
        '/en/pokemon/616-shelmet',
        '<span class="_p28" style="background-position: -140px -1708px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            137,
            72,
            140
        ]
    ],
    '617': [
        'Accelgor',
        '/en/pokemon/617-accelgor',
        '<span class="_p28" style="background-position: -168px -1708px;"></span>',
        '',
        [
            7,
            null
        ],
        [
            190,
            220,
            120
        ]
    ],
    '618': [
        'Stunfisk',
        '/en/pokemon/618-stunfisk',
        '<span class="_p28" style="background-position: -196px -1708px;"></span>',
        '',
        [
            5,
            13
        ],
        [
            240,
            144,
            171
        ]
    ],
    '619': [
        'Mienfoo',
        '/en/pokemon/619-mienfoo',
        '<span class="_p28" style="background-position: -224px -1708px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            128,
            160,
            98
        ]
    ],
    '620': [
        'Mienshao',
        '/en/pokemon/620-mienshao',
        '<span class="_p28" style="background-position: 28px -1708px;"></span>',
        '',
        [
            2,
            null
        ],
        [
            163,
            258,
            127
        ]
    ],
    '621': [
        'Druddigon',
        '/en/pokemon/621-druddigon',
        '<span class="_p28" style="background-position: 0px -1736px;"></span>',
        '',
        [
            16,
            null
        ],
        [
            184,
            213,
            170
        ]
    ],
    '622': [
        'Golett',
        '/en/pokemon/622-golett',
        '<span class="_p28" style="background-position: -28px -1736px;"></span>',
        '',
        [
            5,
            8
        ],
        [
            153,
            127,
            92
        ]
    ],
    '623': [
        'Golurk',
        '/en/pokemon/623-golurk',
        '<span class="_p28" style="background-position: -56px -1736px;"></span>',
        '',
        [
            5,
            8
        ],
        [
            205,
            222,
            154
        ]
    ],
    '624': [
        'Pawniard',
        '/en/pokemon/624-pawniard',
        '<span class="_p28" style="background-position: -84px -1736px;"></span>',
        '',
        [
            17,
            9
        ],
        [
            128,
            154,
            114
        ]
    ],
    '625': [
        'Bisharp',
        '/en/pokemon/625-bisharp',
        '<span class="_p28" style="background-position: -112px -1736px;"></span>',
        '',
        [
            17,
            9
        ],
        [
            163,
            232,
            176
        ]
    ],
    '626': [
        'Bouffalant',
        '/en/pokemon/626-bouffalant',
        '<span class="_p28" style="background-position: -140px -1736px;"></span>',
        '',
        [
            1,
            null
        ],
        [
            216,
            195,
            182
        ]
    ],
    '627': [
        'Rufflet',
        '/en/pokemon/627-rufflet',
        '<span class="_p28" style="background-position: -168px -1736px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            172,
            150,
            97
        ]
    ],
    '628': [
        'Braviary',
        '/en/pokemon/628-braviary',
        '<span class="_p28" style="background-position: -196px -1736px;"></span>',
        '',
        [
            1,
            3
        ],
        [
            225,
            232,
            152
        ]
    ],
    '629': [
        'Vullaby',
        '/en/pokemon/629-vullaby',
        '<span class="_p28" style="background-position: -224px -1736px;"></span>',
        '',
        [
            17,
            3
        ],
        [
            172,
            105,
            139
        ]
    ],
    '630': [
        'Mandibuzz',
        '/en/pokemon/630-mandibuzz',
        '<span class="_p28" style="background-position: 28px -1736px;"></span>',
        '',
        [
            17,
            3
        ],
        [
            242,
            129,
            205
        ]
    ],
    '631': [
        'Heatmor',
        '/en/pokemon/631-heatmor',
        '<span class="_p28" style="background-position: 0px -1764px;"></span>',
        '',
        [
            10,
            null
        ],
        [
            198,
            204,
            129
        ]
    ],
    '632': [
        'Durant',
        '/en/pokemon/632-durant',
        '<span class="_p28" style="background-position: -28px -1764px;"></span>',
        '',
        [
            7,
            9
        ],
        [
            151,
            217,
            188
        ]
    ],
    '633': [
        'Deino',
        '/en/pokemon/633-deino',
        '<span class="_p28" style="background-position: -56px -1764px;"></span>',
        '',
        [
            17,
            16
        ],
        [
            141,
            116,
            93
        ]
    ],
    '634': [
        'Zweilous',
        '/en/pokemon/634-zweilous',
        '<span class="_p28" style="background-position: -84px -1764px;"></span>',
        '',
        [
            17,
            16
        ],
        [
            176,
            159,
            135
        ]
    ],
    '635': [
        'Hydreigon',
        '/en/pokemon/635-hydreigon',
        '<span class="_p28" style="background-position: -112px -1764px;"></span>',
        '',
        [
            17,
            16
        ],
        [
            211,
            256,
            188
        ]
    ],
    '636': [
        'Larvesta',
        '/en/pokemon/636-larvesta',
        '<span class="_p28" style="background-position: -140px -1764px;"></span>',
        '',
        [
            7,
            10
        ],
        [
            146,
            156,
            107
        ]
    ],
    '637': [
        'Volcarona',
        '/en/pokemon/637-volcarona',
        '<span class="_p28" style="background-position: -168px -1764px;"></span>',
        '',
        [
            7,
            10
        ],
        [
            198,
            264,
            189
        ]
    ],
    '638': [
        'Cobalion',
        '/en/pokemon/638-cobalion',
        '<span class="_p28" style="background-position: -196px -1764px;"></span>',
        '',
        [
            9,
            2
        ],
        [
            209,
            192,
            229
        ]
    ],
    '639': [
        'Terrakion',
        '/en/pokemon/639-terrakion',
        '<span class="_p28" style="background-position: -224px -1764px;"></span>',
        '',
        [
            6,
            2
        ],
        [
            209,
            260,
            192
        ]
    ],
    '640': [
        'Virizion',
        '/en/pokemon/640-virizion',
        '<span class="_p28" style="background-position: 28px -1764px;"></span>',
        '',
        [
            12,
            2
        ],
        [
            209,
            192,
            229
        ]
    ],
    '641': [
        'Tornadus',
        '/en/pokemon/641-tornadus',
        '<span class="_p28" style="background-position: 0px -1792px;"></span>',
        '',
        [
            3,
            null
        ],
        [
            188,
            266,
            164
        ]
    ],
    '642': [
        'Thundurus',
        '/en/pokemon/642-thundurus',
        '<span class="_p28" style="background-position: -28px -1792px;"></span>',
        '',
        [
            13,
            3
        ],
        [
            188,
            266,
            164
        ]
    ],
    '643': [
        'Reshiram',
        '/en/pokemon/643-reshiram',
        '<span class="_p28" style="background-position: -56px -1792px;"></span>',
        '',
        [
            16,
            10
        ],
        [
            205,
            275,
            211
        ]
    ],
    '644': [
        'Zekrom',
        '/en/pokemon/644-zekrom',
        '<span class="_p28" style="background-position: -84px -1792px;"></span>',
        '',
        [
            16,
            13
        ],
        [
            205,
            275,
            211
        ]
    ],
    '645': [
        'Landorus',
        '/en/pokemon/645-landorus',
        '<span class="_p28" style="background-position: -112px -1792px;"></span>',
        '',
        [
            5,
            3
        ],
        [
            205,
            261,
            182
        ]
    ],
    '646': [
        'Kyurem',
        '/en/pokemon/646-kyurem',
        '<span class="_p28" style="background-position: -140px -1792px;"></span>',
        '',
        [
            16,
            15
        ],
        [
            245,
            246,
            170
        ]
    ],
    '647': [
        'Keldeo',
        '/en/pokemon/647-keldeo',
        '<span class="_p28" style="background-position: -168px -1792px;"></span>',
        '',
        [
            11,
            2
        ],
        [
            209,
            260,
            192
        ]
    ],
    '648': [
        'Meloetta',
        '/en/pokemon/648-meloetta',
        '<span class="_p28" style="background-position: -196px -1792px;"></span>',
        '',
        [
            1,
            14
        ],
        [
            225,
            250,
            225
        ]
    ],
    '649': [
        'Genesect',
        '/en/pokemon/649-genesect',
        '<span class="_p28" style="background-position: -224px -1792px;"></span>',
        '',
        [
            7,
            9
        ],
        [
            174,
            252,
            199
        ]
    ],
    '808': [
        'Meltan',
        '/en/pokemon/808-meltan',
        '<span class="_p28" style="background-position: -196px -2240px;"></span>',
        ' p-mythical',
        [
            9,
            null
        ],
        [
            130,
            118,
            99
        ]
    ],
    '809': [
        'Melmetal',
        '/en/pokemon/809-melmetal',
        '<span class="_p28" style="background-position: -224px -2240px;"></span>',
        ' p-mythical',
        [
            9,
            null
        ],
        [
            264,
            226,
            190
        ]
    ]
};

// eslint-disable-next-line no-unused-vars
var Dict = {};
export const types = ["",
    'Normal',
    'Fighting',
    'Flying',
    'Poison',
    'Ground',
    'Rock',
    'Bug',
    'Ghost',
    'Steel',
    'Fire',
    'Water',
    'Grass',
    'Electric',
    'Psychic',
    'Ice',
    'Dragon',
    'Dark',
    'Fairy'
];

let data = {};
const axios = require('axios');

// let merge = (obj1, obj2) => ({...obj1, ...obj2});
// const merge = (arr1, arr2) => {
//     const temp = []
//
//     arr1.forEach(x => {
//         arr2.forEach(y => {
//             if (x.id === y.id) {
//                 temp.push({ ...x, ...y })
//             }
//         })
//     })
//
//     return temp
// }
// let master = localStorage.getItem('master');
// if(master==null){
//     axios.get('/GAME_MASTER.json')
//         .then(function (response) {
//             // eslint-disable-next-line no-undef
//             data.master = response.data;
//             localStorage.setItem('master', JSON.stringify(data.master));
//         }).catch(function (error) {
//         console.error('Failed load master' + error.status);
//     });
// }else{
//     data.master = JSON.parse(master);
// }


let effect = localStorage.getItem('effectiveness');
if(effect==null){
    axios.get('type_effectiveness.json')
        .then(function (response) {
            // eslint-disable-next-line no-undef
            data.effect = response.data;
            localStorage.setItem('effectiveness', JSON.stringify(data.effect));
        }).catch(function (error) {
        console.error('Failed load effect' + error.status);
    });
}else{
    data.effect = JSON.parse(effect);
}

let ch_moves = localStorage.getItem('charged_moves');
if(ch_moves==null){
    axios.get('charged_moves.json')
        .then(function (response) {
            // eslint-disable-next-line no-undef
            data.charged_moves = response.data;
            localStorage.setItem('charged_moves', JSON.stringify(data.charged_moves));
        }).catch(function (error) {
        console.error('Failed load charged moves ' + error.status);
    });
}else{
    data.charged_moves = JSON.parse(ch_moves);
}

let f_moves = localStorage.getItem('fast_moves');
if(f_moves==null){
    axios.get('fast_moves.json')
        .then(function (response) {
            // eslint-disable-next-line no-undef
            data.fast_moves = response.data;
            localStorage.setItem('fast_moves', JSON.stringify(data.fast_moves));
        }).catch(function (error) {
        console.error('Failed load fast moves ' + error.status);
    });
}else{
    data.fast_moves = JSON.parse(f_moves);
}

let c_ch_moves = localStorage.getItem('combat_charged_moves');
if(c_ch_moves==null){
    axios.get('combat_charged_moves.json')
        .then(function (response) {
            // eslint-disable-next-line no-undef
            // data.c_charged_moves = merge(data.charged_moves, response.data).values();
            data.c_charged_moves = response.data;
            localStorage.setItem('combat_charged_moves', JSON.stringify(data.c_charged_moves));
        }).catch(function (error) {
        console.error('Failed load charged moves' + error.status + error);
    });
}else{
    data.c_charged_moves = JSON.parse(c_ch_moves);
}

let c_f_moves = localStorage.getItem('combat_fast_moves');
if(c_f_moves==null){
    axios.get('combat_fast_moves.json')
        .then(function (response) {
            // eslint-disable-next-line no-undef
            // data.c_fast_moves = merge(data.fast_moves, response.data).values();
            data.c_fast_moves = response.data;
            localStorage.setItem('combat_fast_moves', JSON.stringify(data.c_fast_moves));
        }).catch(function (error) {
        console.error('Failed load fast moves' + error.status  + error);
    });
}else{
    data.c_fast_moves = JSON.parse(c_f_moves);
}

let curr_pokemon_moves = localStorage.getItem('current_pokemon_moves');
if(curr_pokemon_moves==null){
    axios.get('current_pokemon_moves.json')
        .then(function (response) {
            // eslint-disable-next-line no-undef
            data.current_moves = response.data;
            localStorage.setItem('current_pokemon_moves', JSON.stringify(data.current_moves));
        }).catch(function (error) {
        console.error('Failed load fast moves' + error.status);
    });
}else{
    data.current_moves = JSON.parse(curr_pokemon_moves);
}


export const effectiveness = data.effect;
export const charged_moves = data.charged_moves;
export const fast_moves = data.fast_moves;
export const current_moves = data.current_moves;
export const c_fast_moves = data.c_fast_moves;
export const c_charged_moves = data.c_charged_moves;

Dict.tooltip = {
    'move': 'Move',
    'pokemon': 'Pokémon',
    'strongvs': 'Strong vs.',
    'weakvs': 'Weak vs.'
};

export const combat_setting={
        "roundDurationSeconds": 270.0,
        "turnDurationSeconds": 0.5,
        "minigameDurationSeconds": 7.0,
        "sameTypeAttackBonusMultiplier": 1.2,
        "fastAttackBonusMultiplier": 1.3,
        "chargeAttackBonusMultiplier": 1.3,
        "defenseBonusMultiplier": 1.0,
        "minigameBonusBaseMultiplier": 0.0001,
        "minigameBonusVariableMultiplier": 1.0,
        "maxEnergy": 100,
        "defenderMinigameMultiplier": 1.0,
        "changePokemonDurationSeconds": 12.0,
        "minigameSubmitScoreDurationSeconds": 10.0,
        "quickSwapCooldownDurationSeconds": 60.0,
        "chargeScoreBase": 0.25,
        "chargeScoreNice": 0.5,
        "chargeScoreGreat": 0.75,
        "chargeScoreExcellent": 1.0

};

export const stat_stage={
        "minimumStatStage": -4,
        "maximumStatStage": 4,
        "attackBuffMultiplier": [
            0.5,
            0.5714286,
            0.6666667,
            0.8,
            1.0,
            1.25,
            1.5,
            1.75,
            2.0
        ],
        "defenseBuffMultiplier": [
            0.5,
            0.5714286,
            0.6666667,
            0.8,
            1.0,
            1.25,
            1.5,
            1.75,
            2.0
        ]
};


export const cpm = [ //2,3,4,5,6
    0,//0
    0.094,//1
    0.1351374318,//1,5
    0.16639787,//2
    0.192650919,//2,5
    0.21573247,
    0.2365726613,
    0.25572005,
    0.2735303812,
    0.29024988,//5
    0.3060573775,
    0.3210876,
    0.3354450362,
    0.34921268,
    0.3624577511,
    0.3752356,//
    0.387592416,
    0.39956728,
    0.4111935514,
    0.4225,//10
    0.4329264091,
    0.44310755,
    0.4530599591,
    0.4627984,
    0.472336093,
    0.48168495,
    0.4908558003,
    0.49985844,
    0.508701765,//14.5
    0.51739395,//15
    0.5259425113,
    0.5343543,
    0.5426357375,
    0.5507927,
    0.5588305862,
    0.5667545,
    0.5745691333,
    0.5822789,
    0.5898879072,
    0.5974,
    0.6048236651,
    0.6121573,
    0.6194041216,
    0.6265671,
    0.6336491432,
    0.64065295,
    0.6475809666,
    0.65443563,
    0.6612192524,
    0.667934,
    0.6745818959,
    0.6811649,
    0.6876849038,
    0.69414365,
    0.70054287,
    0.7068842,
    0.7131691091,
    0.7193991,
    0.7255756136,
    0.7317,
    0.7347410093,
    0.7377695,
    0.7407855938,
    0.74378943,
    0.7467812109,
    0.74976104,
    0.7527290867,
    0.7556855,
    0.7586303683,
    0.76156384,
    0.7644860647,
    0.76739717,
    0.7702972656,
    0.7731865,
    0.7760649616,
    0.77893275,
    0.7817900548,
    0.784637,
    0.7874736075,
    0.7903,//40
    0.7903,//
    0.79530001,//41
    0.79530001,
    0.8003,//42
    0.8003,
    0.8053,//43
    0.8053,
    0.81029999,//44
    0.81029999,
    0.81529999,//45
    0.81529999,
];
// eslint-disable-next-line no-unused-vars
export const pokemon_name_id = Object.keys(pokemon_data).map(k => {
    return {label: pokemon_data[k][0], code: k}
});
// ({{[k]: pokemon_data[k][0], id:k }})));
// const exp = {pokemon_names, cpm};
export default {
    pokemon_data,
    cpm,
    types,
    effectiveness,
    charged_moves,
    fast_moves,
    c_charged_moves,
    c_fast_moves,
    current_moves,
    pokemon_name_id,
    combat_setting
};